import {Card} from 'primereact/card';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import NumberFormat from 'react-number-format';
import readXlsxFile from 'read-excel-file';
import {v4 as uuidv4} from 'uuid';
import BaseContainer from '../baseContainers/BaseContainer';
import {ActionButton} from '../components/ActionButton';
import {CustomMessages} from '../components/CustomMessages';
import DivContainer from '../components/DivContainer';
import EditableDataTableExt from '../components/EditableDataTableExt';
import MenuItemIcon from '../components/MenuItemIcon';
import {Steps} from '../components/StepsComponent';
import TooltipComponent from '../components/TooltipComponent';
import YesNoDialog from '../components/YesNoDialog';
import InputCheckboxComponent from '../components/inputs/InputCheckboxComponent';
import InputDropdownComponent from '../components/inputs/InputDropdownComponent';
import InputFileChooseComponent from '../components/inputs/InputFileChooseComponent';
import InputNumberComponent from '../components/inputs/InputNumberComponent';
import InputRadioButtonComponent from '../components/inputs/InputRadioButtonComponent';
import InputTextComponent from '../components/inputs/InputTextComponent';
import BlockUi from '../components/waitPanel/BlockUi';
import OrderCardModel from '../model/OrderCardModel';
import AccountService from '../services/AccountService';
import CardOrderService from '../services/CardOrderService';
import CardOrderTemplateService from '../services/CardOrderTemplateService';
import CardService from '../services/CardService';
import SettingService from '../services/SettingService';
import CardAgreementTermDialog from './CardAgreementTermDialog';
import {LimitsSummaryContainer} from './LimitsSummaryContainer';
import OrderCardConfirmationDialog from './OrderCardConfirmationDialog';
import BannerComponent from '../components/BannerComponent';
import MenuItemIconCardType from '../components/MenuItemIconCardType';
class CardOrderContainer extends BaseContainer {
    constructor(props) {
        super(props);
        const {t} = props;
        this.service = new CardOrderService();
        this.cardOrderTemplateService = new CardOrderTemplateService();
        this.cardService = new CardService();
        this.settingService = new SettingService();
        this.accountService = new AccountService();
        this.renderFirstPage = this.renderFirstPage.bind(this);
        this.renderSecondPage = this.renderSecondPage.bind(this);
        this.renderThirdPage = this.renderThirdPage.bind(this);
        this.renderFourthPage = this.renderFourthPage.bind(this);
        this.renderBackButton = this.renderBackButton.bind(this);
        this.renderNextButton = this.renderNextButton.bind(this);
        this.renderStepsNav = this.renderStepsNav.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleAddCard = this.handleAddCard.bind(this);
        this.user = this.authService.getProfile();
        this.handleCloseConfimationDialog = this.handleCloseConfimationDialog.bind(this);
        this.handleAfterFileChange = this.handleAfterFileChange.bind(this);
        this.handleAfterRemoveFile = this.handleAfterRemoveFile.bind(this);
        this.changeRoleForAll = this.changeRoleForAll.bind(this);
        this.changeRoleForCard = this.changeRoleForCard.bind(this);
        this.handleValidForm = this.handleValidForm.bind(this);
        this.showProgres = this.showProgres.bind(this);
        this.showConfirmationRemoveFileDialog = this.showConfirmationRemoveFileDialog.bind(this);
        this.hideConfirmationRemoveFileDialog = this.hideConfirmationRemoveFileDialog.bind(this);
        this.renderEmptyFileTemplate = this.renderEmptyFileTemplate.bind(this);
        this.handleShowTooltip = this.handleShowTooltip.bind(this);
        this.handleHideTooltip = this.handleHideTooltip.bind(this);
        this.setAllPlastic = this.setAllPlastic.bind(this);
        this.handleDeleteSelectedCards = this.handleDeleteSelectedCards.bind(this);
        this.setAllCardsLimitedAccess = this.setAllCardsLimitedAccess.bind(this);

        this.state = {
            pageIndex: 1,
            element: new OrderCardModel(),
            balance: {},
            amount: props.amount ? props.amount : 0,
            roleOpt: [
                {enumValue: 'DRIVER', label: t('CardRole.DRIVER')},
                {enumValue: 'ADMIN', label: t('CardRole.ADMIN')},
            ],
            confirmationDialogVisibile: false,
            fileProgress: 0,
            progressVisible: false,
            removeFileConfirmationVisible: false,
            mpkTooltipVisible: false,
            allPlastic: false,
            selectedCards: [],
            orderResponse: {},
            telephoneCodeOptions: [],
            agreementTermDialog: false,
            selectedSelectableItem: undefined,
            acceptedTermsList: [],
        };
    }
    componentWillUnmount() {
        this._isMounted = false;
        window.removeEventListener('scroll', this.handleScroll, true);
    }

    componentDidMount() {
        super.componentDidMount();
        const {t} = this.props;
        this.cardService
            .getCardOrderPrice()
            .then((res) => this.setState({orderPlasticCardPrice: res.price}))
            .catch((err) => this.showErrorMessage(t('error.orderPlasticCardPriceError')));
        this.settingService
            .getTelephoneCodeList()
            .then((telephoneCodeOptions) => {
                if (this._isMounted) {
                    this.setState({
                        telephoneCodeOptions: telephoneCodeOptions,
                    });
                }
            })
            .catch(() => {});
            this.settingService
            .getVehicleTypes()
            .then((vehicleTypeOpt) => {
                if (this._isMounted) {
                    this.setState({
                        vehicleTypeOpt,
                    });
                }
            })
            .catch(() => {});
            if(this.authService.getProfile().agreementType === 'CASH') {
                this.setRegularCardIfAgreementCash();
            }
        if (this.props.template && this.props.viewMode === 'EDIT' && !!this.props.elementId) {
            this.cardOrderTemplateService
                .get(this.props.elementId)
                .then((data) => {
                    data.id = undefined;
                    data.cardList = [];
                    this.setState({loading: false, element: data}, () => this.setState({pageIndex: 3}, () => this.unblockUi()));
                    this.setCardTypeForCardFromTemplate(data);
                })
                .catch((err) => {
                    this.showErrorMessage(t('error.getOrderCardTemplateError'));
                    window.location.href = this.props.backUrl;
                });
        } else if (this.props.viewMode === 'EDIT' && !!this.props.elementId) {
            this.service
                .get(this.props.elementId)
                .then((data) => {
                    this.setState({loading: false, element: OrderCardModel.copy(data, t)}, () =>
                        this.setState({pageIndex: 3}, () => this.unblockUi())
                    );
                })
                .catch((err) => {
                    this.showErrorMessage(t('error.getOrderCardTemplateError'));

                    window.location.href = this.props.backUrl;
                });
        } else {
            this.cardOrderTemplateService
                .getFleetGoodGroup()
                .then((res) => {
                    this.setState((prevState) => ({
                        ...prevState,
                        element: {
                            ...prevState.element,
                            petrols: res.petrols,
                            products: res.products,
                            services: res.services,
                        },
                    }));
                })
                .catch(() => {
                    this.unblockUi();
                    this.showErrorMessage(t('error.fleetGoodGroupOptionsError'));
                });
        }
    }

    handleShowTooltip() {
        this.setState({mpkTooltipVisible: true});
    }
    handleHideTooltip() {
        this.setState({mpkTooltipVisible: false});
    }


    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderFirstPage() {

        const {t} = this.props;
        return (
            <React.Fragment>
                <DivContainer colClass=''>
                    <DivContainer colClass='row'>
                        <div className='header'>{`1. ${t('order-card.cardTypeHeader')}`} </div>
                    </DivContainer>
                    <DivContainer colClass='row order-type-icon'>
                        <DivContainer colClass='col-xl-3 col-lg-3 col-md-6 col-sm-12'>
                            <MenuItemIcon
                                alt={t('EcCardKind.FIRM')}
                                className={`icon-svg left ${this.state.element?.cardKind === 'FIRM' ? `selected` : ``}`}
                                iconSvg={'ico_firm_card_order'}
                                handleClick={() => {
                                    this.setState((prevState) => ({
                                        element: {
                                            ...prevState.element,
                                            driverRequired: false,
                                            vehicleRequired: true,
                                            cardKind: 'FIRM',
                                        },
                                    }));
                                }}
                            />
                        </DivContainer>
                        <DivContainer colClass='col-xl-3 col-lg-3 col-md-6 col-sm-12'>
                            <MenuItemIcon
                                alt={t('EcCardKind.VEHICLE')}
                                className={`icon-svg left ${this.state.element?.cardKind === 'VEHICLE' ? `selected` : ``}`}
                                iconSvg={'ico_vehicle_card_order'}
                                handleClick={() => {
                                    this.setState((prevState) => ({
                                        element: {
                                            ...prevState.element,
                                            vehicleRequired: true,
                                            driverRequired: false,
                                            cardKind: 'VEHICLE',
                                        },
                                    }));
                                }}
                            />
                        </DivContainer>

                        <DivContainer colClass='col-xl-3 col-lg-3 col-md-6 col-sm-12'>
                            <MenuItemIcon
                                alt={t('EcCardKind.VEHICLE_PERSON')}
                                className={`icon-svg right ${this.state.element?.cardKind === 'VEHICLE_PERSON' ? `selected` : ``}`}
                                iconSvg={'ico_vehicle_person_card_order'}
                                handleClick={() => {
                                    this.setState((prevState) => ({
                                        element: {
                                            ...prevState.element,
                                            vehicleRequired: true,
                                            driverRequired: true,
                                            cardKind: 'VEHICLE_PERSON',
                                        },
                                    }));
                                }}
                            />
                        </DivContainer>
                        <DivContainer colClass='col-xl-3 col-lg-3 col-md-6 col-sm-12'>
                            <MenuItemIcon
                                alt={t('EcCardKind.PERSON')}
                                className={`icon-svg right ${this.state.element?.cardKind === 'PERSON' ? `selected` : ``}`}
                                iconSvg={'ico_person_card_order'}
                                handleClick={() => {
                                    this.setState((prevState) => ({
                                        element: {
                                            ...prevState.element,
                                            vehicleRequired: false,
                                            driverRequired: true,
                                            cardKind: 'PERSON',
                                        },
                                    }));
                                }}
                            />
                        </DivContainer>
                    </DivContainer>
                </DivContainer>
                <div className='filler' />
                <div className='white-summary-buttons page-wide'>
                    <div className='row footer-buttons'>
                        {this.renderBackButton(1)}
                        {this.renderNextButton(2)}
                    </div>
                </div>
            </React.Fragment>
        );
    }
    renderRequiredHeader() {
        const {t} = this.props;
        const headerItems = [
            {
                label: t('cards.requiredHeaderLabel'),
                type: 'LABEL',
                className: '',
            },
        ];
        return this.prepareHeader(headerItems);
    }
    renderImportHeader() {
        const {t} = this.props;
        const headerItems = [
            {
                label: t('order-card.importHeader'),
                type: 'LABEL',
                className: 'font-16-600 left pageheader-title-16',
            },
        ];
        return this.prepareHeader(headerItems);
    }
    renderSummaryHeader(label = 'order-card.cards') {
        const {t} = this.props;
        const headerItems = [
            {
                label: t(label),
                type: 'LABEL',
                className: 'font-16-600 left pageheader-title-16',
            },
        ];
        return this.prepareHeader(headerItems);
    }
    renderLimitServicesHeader() {
        const {t} = this.props;
        const headerItems = [
            {
                label: t('order-card.limitServices'),
                type: 'LABEL',
                className: 'font-16-600 left',
            },
        ];
        return this.prepareHeader(headerItems);
    }
    renderFleetGoodGroupLimit(effectiveActiveIndex, limitType, summary) {
        const {t} = this.props;
        let limitName;
        if (effectiveActiveIndex === 0) {
            if (limitType === 'quantityLimit') {
                limitName = 'fuelQuantityLimit';
            } else if (limitType === 'amountLimit') {
                limitName = 'fuelAmountLimit';
            }
        } else if (effectiveActiveIndex === 2) {
            limitName = 'notFuelAmountLimit';
            limitType = 'amountLimit';
        } else if (effectiveActiveIndex === 1) {
            limitName = 'serviceAmountLimit';
            limitType = 'amountLimit';
        }
        return !!this.state.element[limitName] ? (
            <React.Fragment>
                <InputCheckboxComponent
                    id={`${limitName}-limit-exist`}
                    name={'limit-exist'}
                    label={t(`cards.${limitType}`)}
                    labelOnRight
                    value={!!this.state.element[limitName].type}
                    validator={this.validator}
                    onChange={(type, params, event) => {
                        let element = this.state.element;
                        if (event.checked) {
                            element[limitName].type = 'DAILY';
                            element[limitName].value = 0;
                        } else {
                            element[limitName].type = undefined;
                            element[limitName].value = undefined;
                        }
                        this.setState({
                            element,
                        });
                    }}
                    viewMode={summary ? 'VIEW' : 'EDIT'}
                    validators='not_required'
                    colClass='col-12'
                >
                    {' '}
                </InputCheckboxComponent>



                <React.Fragment>
                    <InputRadioButtonComponent
                        id={`${limitName}-type`}
                        name='type'
                        colClass='col-12 card-manage-limits'
                        viewMode={summary ? 'VIEW' : 'EDIT'}
                        options={[
                            {enumValue: 'DAILY', label: t('cards.daily')},
                            {enumValue: 'MONTHLY', label: t('cards.monthly')},
                        ]}
                        value={this.state.element[limitName].type}
                        valueLabel='label'
                        labelOnRight
                        itemColClass={'col-xl-6 col-lg-6 col-md-6 col-sm-6'}
                        onChange={this.handleChange}
                        showLabel={false}
                        validator={this.validator}
                        validators='required'
                        label={t('cards.timeTypeLabel')}
                        rendered={!!this.state.element[limitName].type}
                        valueKey='enumValue'
                        stateField={`element.${limitName}`}
                    />
                    <InputNumberComponent
                        id={`${limitName}-value`}
                        name='value'
                        label={t(`cards.${limitType}`)}
                        value={this.state.element[limitName].value}
                        validator={this.validator}
                        validators='required'
                        onChange={this.handleChange}
                        viewMode={summary ? 'VIEW' : 'EDIT'}
                        min={0}
                        inputStyle={{width: '100%'}}
                        colClass='col-12'
                        rendered={!!this.state.element[limitName].type}
                        placeholder={'0'}
                        stateField={`element.${limitName}`}
                    />
                      <div className={'fleet-good-group-banner-limits'}>
                <BannerComponent
                    key={'header-banner'}
                    label={t('cards.limitForEvOnlyMoreInfo')}
                    iconSvg='ico_blue_banner_icon'
                    className='row row-32'
                    iconSide='left'
                    rendered={this.state.element.multienergeticSelected=== true && this.state.element[`petrols`].filter((n) => n.name === 'EV')[0]?.selected && limitType === 'quantityLimit'}
                    variant='blue-banner'
                ></BannerComponent>
                </div>
                </React.Fragment>
            </React.Fragment>
        ) : null;
    }

    renderLimits(effectiveActiveIndex, summary) {
        const {t} = this.props;
        return (
            <DivContainer colClass='row'>
                <label className='limits-label'>{t('cards.limits')}</label>
                {effectiveActiveIndex === 0 ? (
                    <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                        {this.renderFleetGoodGroupLimit(effectiveActiveIndex, 'quantityLimit', summary)}
                    </div>
                ) : null}
                <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                    {this.renderFleetGoodGroupLimit(effectiveActiveIndex, 'amountLimit', summary)}
                </div>
            </DivContainer>
        );
    }
    renderFuelAmountLimit() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <InputCheckboxComponent
                    id={'amountFuelLimit'}
                    name='amountFuelLimit'
                    label={t('cards.amountLimit')}
                    labelOnRight
                    value={this.state.element.amountFuelLimit}
                    validator={this.validator}
                    onChange={this.handleChange}
                    viewMode={'EDIT'}
                    validators='not_required'
                    colClass='col-12'
                    onAfterStateChange={() => {
                        if (this.state.element.amountFuelLimit === false) {
                            this.setState((prevState) => ({
                                element: {
                                    ...prevState.element,
                                    monthlyFuelAmountLimit: 0,
                                    dailyFuelAmountLimit: 0,
                                },
                            }));
                        }
                    }}
                />
                <InputRadioButtonComponent
                    id='timeFuelAmount'
                    name='timeFuelAmount'
                    colClass='col-12'
                    viewMode='EDIT'
                    options={[
                        {enumValue: 'DAILY', label: t('cards.daily')},
                        {enumValue: 'MONTHLY', label: t('cards.monthly')},
                    ]}
                    value={this.state.element.timeFuelAmount}
                    valueLabel='label'
                    labelOnRight
                    valueKey='enumValue'
                    itemColClass={'col-xl-6 col-lg-6 col-md-6 col-sm-6'}
                    onChange={this.handleChange}
                    showLabel={false}
                    validator={this.validator}
                    validators='required'
                    label={t('cards.timeTypeLabel')}
                    rendered={!!this.state.element.amountFuelLimit}
                    onAfterStateChange={() => {
                        if (this.state?.element?.timeFuelAmount === 'DAILY') {
                            this.setState((prevState) => ({
                                element: {
                                    ...prevState.element,
                                    monthlyFuelAmountLimit: 0,
                                },
                            }));
                        } else if (this.state?.element?.timeFuelAmount === 'MONTHLY') {
                            this.setState((prevState) => ({
                                element: {
                                    ...prevState.element,
                                    dailyFuelAmountLimit: 0,
                                },
                            }));
                        }
                    }}
                />
                {this.state.element.timeFuelAmount && this.state.element.timeFuelAmount === 'DAILY' ? (
                    <InputNumberComponent
                        id={'dailyFuelAmountLimit'}
                        name={'dailyFuelAmountLimit'}
                        label={t('cards.amountLimitLabel')}
                        value={this.state.element.dailyFuelAmountLimit}
                        validator={this.validator}
                        validators='required'
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                        min={0}
                        inputStyle={{width: '100%'}}
                        colClass='col-12'
                        rendered={!!this.state.element.amountFuelLimit}
                        placeholder={'0'}
                    />
                ) : (
                    <InputNumberComponent
                        id={'monthlyFuelAmountLimit'}
                        name={'monthlyFuelAmountLimit'}
                        label={t('cards.amountLimitLabel')}
                        value={this.state.element.monthlyFuelAmountLimit}
                        validator={this.validator}
                        validators='required'
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                        min={0}
                        inputStyle={{width: '100%'}}
                        colClass='col-12'
                        rendered={!!this.state.element.amountFuelLimit}
                        placeholder={'0'}
                    />
                )}
            </React.Fragment>
        );
    }
    renderNotFuelAmountLimit(listName) {
        const {t} = this.props;

        return (
            <React.Fragment>
                <InputCheckboxComponent
                    id={listName === 'products' ? 'amountNotFuelLimit' : 'amountServiceLimit'}
                    name={listName === 'products' ? 'amountNotFuelLimit' : 'amountServiceLimit'}
                    label={t('cards.amountLimit')}
                    labelOnRight
                    value={listName === 'products' ? this.state.element.amountNotFuelLimit : this.state.element.amountServiceLimit}
                    validator={this.validator}
                    onChange={this.handleChange}
                    viewMode={'EDIT'}
                    validators='not_required'
                    colClass='col-12'
                    onAfterStateChange={() => {
                        if (listName === 'products' && this.state.element.amountNotFuelLimit === false) {
                            this.setState((prevState) => ({
                                element: {
                                    ...prevState.element,
                                    monthlyNotFuelAmountLimit: 0,
                                    dailyNotFuelAmountLimit: 0,
                                },
                            }));
                        }
                        if (listName === 'services' && this.state.element.amountServiceLimit === false) {
                            this.setState((prevState) => ({
                                element: {
                                    ...prevState.element,
                                    monthlyServiceAmountLimit: 0,
                                    dailyServiceAmountLimit: 0,
                                },
                            }));
                        }
                    }}
                />
                <InputRadioButtonComponent
                    id={listName === 'products' ? 'timeNotFuelAmount' : 'timeServiceAmount'}
                    name={listName === 'products' ? 'timeNotFuelAmount' : 'timeServiceAmount'}
                    colClass='col-12'
                    viewMode='EDIT'
                    options={[
                        {enumValue: 'DAILY', label: t('cards.daily')},
                        {enumValue: 'MONTHLY', label: t('cards.monthly')},
                    ]}
                    value={listName === 'products' ? this.state.element.timeNotFuelAmount : this.state.element.timeServiceAmount}
                    valueLabel='label'
                    labelOnRight
                    valueKey='enumValue'
                    itemColClass={'col-xl-6 col-lg-6 col-md-6 col-sm-6'}
                    onChange={this.handleChange}
                    showLabel={false}
                    validator={this.validator}
                    validators='required'
                    label={t('cards.timeTypeLabel')}
                    rendered={
                        (listName === 'products' && !!this.state.element.amountNotFuelLimit) ||
                        (listName === 'services' && !!this.state.element.amountServiceLimit)
                    }
                    onAfterStateChange={() => {
                        if (listName === 'products') {
                            if (this.state?.element?.timeNotFuelAmount === 'DAILY') {
                                this.setState((prevState) => ({
                                    element: {
                                        ...prevState.element,
                                        monthlyNotFuelAmountLimit: 0,
                                    },
                                }));
                            } else if (this.state?.element?.timeNotFuelAmount === 'MONTHLY') {
                                this.setState((prevState) => ({
                                    element: {
                                        ...prevState.element,
                                        dailyNotFuelAmountLimit: 0,
                                    },
                                }));
                            }
                        }
                        if (listName === 'services') {
                            if (this.state?.element?.timeServiceAmount === 'DAILY') {
                                this.setState((prevState) => ({
                                    element: {
                                        ...prevState.element,
                                        monthlyServiceAmountLimit: 0,
                                    },
                                }));
                            } else if (this.state?.element?.timeServiceAmount === 'MONTHLY') {
                                this.setState((prevState) => ({
                                    element: {
                                        ...prevState.element,
                                        dailyServiceAmountLimit: 0,
                                    },
                                }));
                            }
                        }
                    }}
                />
                {listName === 'products' && this.state.element.timeNotFuelAmount ? (
                    this.state.element.timeNotFuelAmount === 'DAILY' ? (
                        <InputNumberComponent
                            id={'dailyNotFuelAmountLimit'}
                            name={'dailyNotFuelAmountLimit'}
                            label={t('cards.amountLimitLabel')}
                            value={this.state.element.dailyNotFuelAmountLimit}
                            validator={this.validator}
                            validators='required'
                            onChange={this.handleChange}
                            viewMode={'EDIT'}
                            min={0}
                            inputStyle={{width: '100%'}}
                            colClass='col-12'
                            rendered={!!this.state.element.amountNotFuelLimit}
                            placeholder={'0'}
                        />
                    ) : (
                        <InputNumberComponent
                            id={'monthlyNotFuelAmountLimit'}
                            name={'monthlyNotFuelAmountLimit'}
                            label={t('cards.amountLimitLabel')}
                            value={this.state.element.monthlyNotFuelAmountLimit}
                            validator={this.validator}
                            validators='required'
                            onChange={this.handleChange}
                            viewMode={'EDIT'}
                            min={0}
                            inputStyle={{width: '100%'}}
                            colClass='col-12'
                            rendered={!!this.state.element.amountNotFuelLimit}
                            placeholder={'0'}
                        />
                    )
                ) : null}
                {listName === 'services' && this.state.element.timeServiceAmount ? (
                    this.state.element.timeServiceAmount === 'DAILY' ? (
                        <InputNumberComponent
                            id={'dailyServiceAmountLimit'}
                            name={'dailyServiceAmountLimit'}
                            label={t('cards.amountLimitLabel')}
                            value={this.state.element.dailyServiceAmountLimit}
                            validator={this.validator}
                            validators='required'
                            onChange={this.handleChange}
                            viewMode={'EDIT'}
                            min={0}
                            inputStyle={{width: '100%'}}
                            colClass='col-12'
                            rendered={!!this.state.element.amountServiceLimit}
                            placeholder={'0'}
                        />
                    ) : (
                        <InputNumberComponent
                            id={'monthlyServiceAmountLimit'}
                            name={'monthlyServiceAmountLimit'}
                            label={t('cards.amountLimitLabel')}
                            value={this.state.element.monthlyServiceAmountLimit}
                            validator={this.validator}
                            validators='required'
                            onChange={this.handleChange}
                            viewMode={'EDIT'}
                            min={0}
                            inputStyle={{width: '100%'}}
                            colClass='col-12'
                            rendered={!!this.state.element.amountServiceLimit}
                            placeholder={'0'}
                        />
                    )
                ) : null}
            </React.Fragment>
        );
    }
    checkIfAgreementTermIsAlreadyAccepted(product) {
        const {t} = this.props;
        let listOfAgreementTermFileNamesAll = this.state.element['petrols']
            .filter((el) => el.agreementTermPetraId !== null)
            .map((el) => el.agreementTermPetraId);
        if (
            listOfAgreementTermFileNamesAll.includes(product.agreementTermPetraId) &&
            !this.authService.isProductAgreementTermAccepted(product.agreementTermPetraId)
        ) {
            this.accountService
                .isAgreementTermAccepted(product.agreementTermPetraId)
                .then((result) => {
                    if (result === false) {
                        console.log('checkIfAgreementTermIsAlreadyAccepted', product);
                        this.unblockUi(
                            this.setState({
                                agreementTermDialog: true,
                                selectedSelectableItem: product,
                            })
                        );
                    }
                })
                .catch(() => {
                    this.unblockUi();
                    this.showErrorMessage(t('error.isAgreementTermAcceptedError'));
                });
        }
        //TODO
        if (product.name === 'ALL') {   
            if(this.state.element.regularCardSelected === true){
                listOfAgreementTermFileNamesAll = this.state.element['petrols']
                .filter((el) => (el.agreementTermPetraId !== null && el.name !== 'EV'))
                .map((el) => el.agreementTermPetraId);
               } 
            listOfAgreementTermFileNamesAll.forEach((element) => {
                this.accountService
                    .isAgreementTermAccepted(element)
                    .then((result) => {
                        if (result === false) {
                            this.unblockUi(
                                this.setState({
                                    agreementTermDialog: true,
                                    selectedSelectableItem: product,
                                })
                            );
                        }
                    })
                    .catch(() => {
                        this.unblockUi();
                        this.showErrorMessage(t('error.isAgreementTermAcceptedError'));
                    });
            });
        }
    }
    renderItems(listName, summary) {
        const {t} = this.props;
        let allSelected = false;
        if (this.state.element[listName] && this.state.element[listName].length) {
            this.state.element[listName].forEach((el) => {
                if(listName === `petrols` && this.state.element.multienergeticSelected === true){
                    if (el.name === 'ALL' && el.selected) {
                        allSelected = true;
                    }
                }
                if(listName !== `petrols`){
                    if (el.name === 'ALL' && el.selected) {
                        allSelected = true;
                    }
                }
            });
        }
        return (
            <div className={'row product-not-fuel-label'}>
                {this.state.element[listName] && this.state.element[listName].length
                    ? this.state.element[listName].map((p, index) => {
                          const color = p.color ? p.color : 'white';
                          const fontColor = p.color ? 'white' : '#090E22';
                          return (
                              <InputCheckboxComponent
                                  key={`${p.name}-${listName}`}
                                  id={`${index}-${listName}`}
                                  name='selected'
                                  label={t(`products.${p.name}`)}
                                  labelOnRight
                                  value={p.selected || allSelected}
                                  disabled={(this.state.element.multienergeticSelected === false && p.name === 'EV') || (listName !== `petrols` && p.name !== 'ALL'  && allSelected === true)}
                                  validator={this.validator}
                                  onChange={this.handleChange}
                                  viewMode={'EDIT'}
                                  validators='not_required'
                                  colClass='col-width-auto'
                                  stateField={`element.${listName}[${index}]`}
                                  grayBorder={!!summary}
                                  transparentBorder={!summary}
                                  labelClassName={`product-label card-details gray-border`}
                                  labelLeftStyle={{
                                      backgroundColor: `${color}`,
                                      color: `${fontColor}`,
                                      padding: '0 4px 0 4px',
                                      marginLeft: '8px',
                                      lineHeight: '24px',
                                      fontSize: '12px',
                                      height: '24px',
                                      marginBottom: 0,
                                  }}
                                  onAfterStateChange={() => {
                                      if (listName === `petrols`) {
                                          if (
                                              (p.agreementTermName !== null && p.agreementTermFileName !== null && p.selected === true) ||
                                              (p.name === 'ALL' && p.selected === true)
                                          ) { 
                                              this.checkIfAgreementTermIsAlreadyAccepted(p);
                                          }
                                          this.setState((prevState) => {
                                              const updatedElements = prevState.element[`${listName}`].map((item) => {
                                                  if (p.name === 'ALL' && p.selected === true && this.state.element.multienergeticSelected === true) { 
                                                      if (item.name !== 'ALL' && item.selected === false) {
                                                          return {...item, selected: true};
                                                      }
                                                  }
                                                  if (p.name === 'ALL' && p.selected === true && this.state.element.multienergeticSelected === false) {
                                                    if (item.name !== 'ALL' && item.name !== 'EV' && item.selected === false) {
                                                        return {...item, selected: true};
                                                    }
                                                }
                                                  if (p.name === 'ALL' && p.selected === false) {
                                                      if (item.name !== 'ALL' && item.selected === true) {
                                                          return {...item, selected: false};
                                                      }
                                                  }
                                                  if (p.name !== 'ALL' && p.selected === false) {
                                                      if (item.name === 'ALL' && item.selected === true) {
                                                          return {...item, selected: false};
                                                      }
                                                  }
                                                  if (p.name !== 'ALL' && p.selected === true) {
                                                      const elementsWithSelectedTrue = prevState.element[`${listName}`].filter(
                                                          (element) => element.selected === true
                                                      );
                                                      const allSelected =
                                                          elementsWithSelectedTrue.length === prevState.element[`${listName}`].length - 1;
                                                      if (allSelected && item.name === 'ALL' && item.selected === false) {
                                                          return {...item, selected: true};
                                                      }
                                                  }
                                                  return item;
                                              });
                                              return {
                                                  element: {
                                                      ...prevState.element,
                                                      [listName]: updatedElements,
                                                  },
                                              };
                                          });
                                      }
                                  }}
                              />
                          );
                      })
                    : null}
            </div>
        );
    }
    renderTransactionLimitHeader() {
        const {t} = this.props;
        const headerItems = [
            {
                label: t('order-card.transactionLimitsHeader'),
                type: 'LABEL',
                className: '',
            },
        ];
        return this.prepareHeader(headerItems);
    }
    renderCardTypeHeader() {
        const {t} = this.props;
        const headerItems = [
            {
                label: t('order-card.orderCardTypeHeader'),
                type: 'LABEL',
                className: '',
            },
        ];
        return this.prepareHeader(headerItems);
    }
    renderFleetGoodGroupHeder(label) {
        const headerItems = [
            {
                label,
                type: 'LABEL',
                className: '',
            },
        ];
        return this.prepareHeader(headerItems);
    }

    setRegularCardIfAgreementCash(){
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                multienergeticSelected: false,
                regularCardSelected: true,
            },
        }));
       }
       setCardTypeForCardFromTemplate(data){
        if(data.electro === true && this.authService.getProfile().agreementType !== 'CASH'){
            this.setState((prevState) => ({
                element: {
                    ...prevState.element,
                    multienergeticSelected: true,
                    regularCardSelected: false,
                },
            }));
        } else {
            this.setState((prevState) => ({
                element: {
                    ...prevState.element,
                    multienergeticSelected: false,
                    regularCardSelected: true,
                },
            }));
        }

       }

    returnCardIconLocation(electro){
        if(electro === true) {
            if( this.authService.getAgreementSourceTypeFromToken() !== 'EC'){
                return  'card_header_electromobility_new'
            } else {
                return  'card_header_electromobility_micro'
            }
        } else {
            if( this.authService.getAgreementSourceTypeFromToken() !== 'EC'){
                if(this.authService.getProfile().agreementType === 'CASH'){
                    return `card_header_cash_new`
                }
                else {
                    return  'card_header_cashless_new'
                }
            } else { 
                if(this.authService.getProfile().agreementType === 'CASH'){
                    return  `card_header_cash_micro`
                }
                else {
                    return  'card_header_cashless_micro'
                }
            }
        }
    }

    renderSecondPage() {
        const {t} = this.props;
        return (
            <DivContainer colClass='row'>
                <div className='header'>{`2. ${t('order-card.setCardDetailsHeader')}`}</div>
                <React.Fragment>
                    <DivContainer colClass='dashboard'>
                        <DivContainer colClass='col-12 dashboard-link-container card-order limits '>
                            <DivContainer colClass='row'>
                                <DivContainer colClass='col-12'>
                                    <Card header={this.renderRequiredHeader()}>
                                        <div className='row row-24'>
                                            <label className='font-14-400 gray'>{t('order-card.requiredDescription')}</label>
                                        </div>
                                        <div className='row'>
                                            <InputCheckboxComponent
                                                id={'vehicleRequired'}
                                                name='vehicleRequired'
                                                label={t('cards.registrationNumberFull')}
                                                labelOnRight
                                                value={this.state.element.vehicleRequired}
                                                validator={this.validator}
                                                onChange={this.handleChange}
                                                viewMode={'EDIT'}
                                                validators='not_required'
                                                colClass='flex-inputs'
                                                disabled={
                                                    this.state.element.cardKind === 'VEHICLE' ||
                                                    this.state.element.cardKind === 'VEHICLE_PERSON'
                                                }
                                            />
                                            <InputCheckboxComponent
                                                id={'driverRequired'}
                                                name='driverRequired'
                                                label={t('cards.fullName')}
                                                labelOnRight
                                                value={this.state.element.driverRequired}
                                                validator={this.validator}
                                                onChange={this.handleChange}
                                                viewMode={'EDIT'}
                                                validators='not_required'
                                                colClass='flex-inputs'
                                                disabled={
                                                    this.state.element.cardKind === 'PERSON' ||
                                                    this.state.element.cardKind === 'VEHICLE_PERSON'
                                                }
                                            />
                                            <InputCheckboxComponent
                                                id={'odometerRequired'}
                                                name='odometerRequired'
                                                label={t('cards.odometer')}
                                                labelOnRight
                                                value={this.state.element.odometerRequired}
                                                validator={this.validator}
                                                onChange={this.handleChange}
                                                viewMode={'EDIT'}
                                                validators='not_required'
                                                colClass='flex-inputs'
                                            />
                                            <div className='mpk-div p-0'>
                                                <InputCheckboxComponent
                                                    id={'mpkRequired'}
                                                    name='mpkRequired'
                                                    label={t('cards.mpk')}
                                                    labelOnRight
                                                    value={this.state.element.mpkRequired}
                                                    validator={this.validator}
                                                    onChange={this.handleChange}
                                                    viewMode={'EDIT'}
                                                    validators='not_required'
                                                    colClass='flex-inputs'
                                                    iconSvg='ico_help_input_label_blue'
                                                    iconSize='mpk-icon'
                                                    iconSide='right'
                                                />
                                                <TooltipComponent
                                                    id='mpk-tooltip'
                                                    key='mpk-tooltip'
                                                    visible={this.state.mpkTooltipVisible}
                                                    content={t('cards.mpkTooltip')}
                                                    eventListeners={[
                                                        {
                                                            eventName: 'mouseleave',
                                                            fnc: this.handleHideTooltip,
                                                            eventElementId: 'ico_help_input_label_blue',
                                                        },
                                                        {
                                                            eventName: 'mouseenter',
                                                            fnc: this.handleShowTooltip,
                                                            eventElementId: 'ico_help_input_label_blue',
                                                        },
                                                    ]}
                                                />
                                            </div>
                                        </div>
                                    </Card>
                                </DivContainer>
                            </DivContainer>
                        </DivContainer>
                    </DivContainer>
                    {this.authService.getProfile().agreementType === 'PREPAID' ||
                      this.authService.getProfile().agreementType === 'CASHLESS'
                                                    ?
                 (   <DivContainer colClass='dashboard'>
                        <DivContainer colClass='col-12 dashboard-link-container card-order limits'>
                            <DivContainer colClass='row'>
                                <DivContainer colClass='col-12'>
                                    <Card header={this.renderCardTypeHeader()}>
                                        <DivContainer colClass='row order-type-icon-class'>
                                        <MenuItemIconCardType
                                                        alt={t('EcCardKind.regularCard')}
                                                        id={`regularCard-type-icon`}
                                                        className={this.state.element.regularCardSelected === true? `row content-of-icon-selected` : `row content-of-icon`}
                                                        iconSvg={this.returnCardIconLocation(false)}
                                                        png={true}
                                                        handleClick={() => {
                                                            let copyElement = [...this.state.element[`petrols`]];
                                                            copyElement.forEach(el => {
                                                                if(el.name === "EV"){
                                                                    el.selected = false;
                                                                }
                                                                if(el.name === "ALL"){
                                                                    el.selected = false;
                                                                }
                                                            })
                                                            this.state.element[`petrols`] = copyElement;
                                                            this.setState((prevState) => ({
                                                                element: {
                                                                    ...prevState.element,
                                                                    multienergeticSelected: false,
                                                                    regularCardSelected: true,
                                                                    [`petrols`]: copyElement
                                                                },
                                                            }));
                                                        }}
                                                        rendered={
                                                            this.authService.getProfile().agreementType === 'PREPAID' ||
                                                            this.authService.getProfile().agreementType === 'CASHLESS'
                                                        }
                                                        elementData={this.state.element}
                                                        headerText={t('cards.cardTypePetrolHeader')}
                                                        contentText={t('cards.cardTypePetrolContent')}
                                                   />
                                                     <MenuItemIconCardType
                                                        alt={t('EcCardKind.regularCard')}
                                                        id={`electroCard-type-icon`}
                                                        className={this.state.element.multienergeticSelected === true ?  `row content-of-icon-selected` : `row content-of-icon`}
                                                        iconSvg={this.returnCardIconLocation(true)}
                                                        png={true}
                                                        handleClick={() => {
                                                            let copyElement = [...this.state.element[`petrols`]];
                                                            copyElement.forEach(el => {
                                                                if(el.name === "EV"){
                                                                    el.selected = false;
                                                                }
                                                                if(el.name === "ALL"){
                                                                    el.selected = false;
                                                                }
                                                            })
                                                            this.state.element[`petrols`] = copyElement;
                                                            this.setState((prevState) => ({
                                                                element: {
                                                                    ...prevState.element,
                                                                    multienergeticSelected: true,
                                                                    regularCardSelected: false,
                                                                    [`petrols`]: copyElement
                                                                },
                                                            }));
                                                        }}
                                                        rendered={
                                                            this.authService.getProfile().agreementType === 'PREPAID' ||
                                                            this.authService.getProfile().agreementType === 'CASHLESS'
                                                        }
                                                        headerText={t('cards.cardTypeMultienergeticHeader')}
                                                        contentText={t('cards.cardTypeMultienergeticContent')}     
                                                    />
                                        </DivContainer>
                                    </Card>
                                </DivContainer>
                            </DivContainer>
                        </DivContainer>
                    </DivContainer>
                       )

                       :   null  }
   
                    <DivContainer colClass='dashboard'>
                        <DivContainer colClass='col-12 dashboard-link-container card-order limits'>
                            <DivContainer colClass='row'>
                                <DivContainer colClass='col-12'>
                                    <Card header={this.renderTransactionLimitHeader()}>
                                        <div className='row row-24'>
                                            <label
                                                className='font-14-400 gray'
                                                dangerouslySetInnerHTML={{__html: `${t('order-card.[html]monthlyAmountLimitDescription')}`}}
                                            ></label>
                                        </div>
                                        <div className='row'>
                                            <InputNumberComponent
                                                id={'monthlyAmountLimit'}
                                                name={'monthlyAmountLimit'}
                                                label={t('order-card.monthlyAmountLimitSummary')}
                                                value={this.state.element.monthlyAmountLimit}
                                                validator={this.validator}
                                                validators='not_required'
                                                onChange={this.handleChange}
                                                viewMode={'EDIT'}
                                                min={0}
                                                colClass='flex-inputs'
                                            />
                                            <InputNumberComponent
                                                id={'dailyVisitLimit'}
                                                name={'dailyVisitLimit'}
                                                label={t('cards.dailyVisitLimit')}
                                                value={this.state.element.dailyVisitLimit}
                                                validator={this.validator}
                                                validators='not_required'
                                                onChange={this.handleChange}
                                                viewMode={'EDIT'}
                                                min={0}
                                                colClass='flex-inputs'
                                            />
                                        </div>
                                    </Card>
                                </DivContainer>
                            </DivContainer>
                        </DivContainer>
                    </DivContainer>
                    <DivContainer colClass='dashboard'>
                        <DivContainer colClass='col-12 dashboard-link-container card-order limits'>
                            <DivContainer colClass='row'>
                                <DivContainer colClass='col-12'>
                                    <Card header={this.renderFleetGoodGroupHeder(t('order-card.petrolHeader'))}>
                                        <div className='row row-32'>{this.renderItems('petrols')}</div>
                                        {this.renderLimits(0)}
                                    </Card>
                                </DivContainer>
                            </DivContainer>
                        </DivContainer>
                    </DivContainer>
                    <DivContainer colClass='dashboard'>
                        <DivContainer colClass='col-12 dashboard-link-container card-order limits'>
                            <DivContainer colClass='row'>
                                <DivContainer colClass='col-12'>
                                    <Card header={this.renderFleetGoodGroupHeder(t('order-card.servicesHeader'))}>
                                        <div className='row row-32'>{this.renderItems('services')}</div>
                                        {this.renderLimits(1)}
                                    </Card>
                                </DivContainer>
                            </DivContainer>
                        </DivContainer>
                    </DivContainer>
                    <DivContainer colClass='dashboard'>
                        <DivContainer colClass='col-12 dashboard-link-container card-order limits'>
                            <DivContainer colClass='row'>
                                <DivContainer colClass='col-12'>
                                    <Card header={this.renderFleetGoodGroupHeder(t('order-card.productsHeader'))}>
                                        <div className='row row-32'>{this.renderItems('products')}</div>
                                        {this.renderLimits(2)}
                                    </Card>
                                </DivContainer>
                            </DivContainer>
                        </DivContainer>
                    </DivContainer>
                </React.Fragment>
                <div className='white-summary-buttons page-wide'>
                    <div className='row footer-buttons '>
                        {this.renderBackButton(1)}
                        {this.renderNextButton(3)}
                    </div>
                </div>
            </DivContainer>
        );
    }

    handleAddCard() {
        const modifiedList = this.state.element.cardList;
        const agreementLimitedAccess = this.user.limitedAccess === true ? true : false;
        modifiedList.push({
            uuid: uuidv4(),
            driver: undefined,
            vehicleRegistration: undefined,
            mpk: undefined,
            accountRole: 'DRIVER',
            phoneNumber: undefined,
            phoneNumberCode: this.state.telephoneCodeOptions[0],
            plastic: false,
            virtual: true,
            electromobility : this.state.element.multienergeticSelected ? true : false,
            limitedAccess: agreementLimitedAccess ? false : undefined,
        });
        this.setState((prevState) => ({
            ...prevState,
            element: {
                ...prevState.element,
                cardList: modifiedList,
            },
        }));
    }
    handleDeleteSelectedCards() {
        this.handleChange(
            'EDITABLE_DATA_TABLE',
            ['REMOVE_ALL', this.state.selectedUuids, 'uuid', true, true],
            {name: 'cardList'},
            () => {
                this.setState({selectedCards: [], selectedUuids: []});
            },
            'element'
        );
    }
    handleAfterFileChange() {
        const {t} = this.props;
        if (this.state.file) {
            this.blockUi();
            const modifiedList = this.state.element.cardList;
            readXlsxFile(this.state.file)
                .then((rows) => {
                    if (rows && rows.length) {
                        const rowsLength = rows.length;
                        const numberOfRowsWhen10PercentProccessed = Math.round(rowsLength / 10);
                        let nextIndexToUpdate10PercentProccessed = numberOfRowsWhen10PercentProccessed;
                        rows.forEach((row, index) => {
                            if (index === nextIndexToUpdate10PercentProccessed - 1) {
                                let currentProgress = parseInt(this.state.fileProgress) + 10;
                                this.setState({fileProgress: parseInt(currentProgress)}, () => {
                                    nextIndexToUpdate10PercentProccessed += numberOfRowsWhen10PercentProccessed;
                                });
                            }
                            if (index !== 0) {
                                let vehicleRegistrationIndex = undefined;
                                let driverIndex = undefined;
                                let phoneNumberIndex = undefined;
                                if (this.state.element.cardKind === 'VEHICLE') {
                                    vehicleRegistrationIndex = 0;
                                    phoneNumberIndex = 1;
                                } else if (this.state.element.cardKind === 'VEHICLE_PERSON') {
                                    vehicleRegistrationIndex = 0;
                                    driverIndex = 1;
                                    phoneNumberIndex = 2;
                                } else if (this.state.element.cardKind === 'PERSON') {
                                    driverIndex = 0;
                                    phoneNumberIndex = 1;
                                } else {
                                    phoneNumberIndex = 0;
                                }
                                let phoneNumber = row[phoneNumberIndex] ? `${row[phoneNumberIndex]}` : '';
                                let phoneNumberCode;
                                let phoneNumberValue;
                                if (phoneNumber !== undefined && phoneNumber !== null && phoneNumber.toString().match(/^[0-9]+$/i)) {
                                    phoneNumber = `(48)${phoneNumber}`;
                                }
                                if (phoneNumber !== undefined && phoneNumber !== null && phoneNumber.startsWith('(')) {
                                    let prefix = phoneNumber.substring(0, phoneNumber.indexOf(')') + 1);
                                    if (prefix !== undefined) {
                                        this.state.telephoneCodeOptions.forEach((element) => {
                                            if (prefix === element.code) {
                                                phoneNumberCode = element;
                                                phoneNumberValue = phoneNumber.substring(phoneNumber.indexOf(')') + 1);
                                            }
                                        });
                                    }
                                }
                                modifiedList.push({
                                    uuid: uuidv4(),
                                    vehicleRegistration: vehicleRegistrationIndex !== undefined ? row[vehicleRegistrationIndex] : undefined,
                                    driver: driverIndex !== undefined ? row[driverIndex].substring(0, 32) : undefined,
                                    phoneNumber: phoneNumber,
                                    phoneNumberCode: phoneNumberCode,
                                    phoneNumberValue: phoneNumberValue,
                                    accountRole: row[phoneNumberIndex + 1] ? row[phoneNumberIndex + 1].toUpperCase() : undefined,
                                    plastic: row[phoneNumberIndex + 2]
                                        ? row[phoneNumberIndex + 2].toUpperCase() === t('details.yes')
                                        : false,
                                    virtual: true,
                                    vehicleType: row[phoneNumberIndex + 3] ? row[phoneNumberIndex + 3].toUpperCase() : undefined,
                                    limitedAccess: row[phoneNumberIndex + 4] ? row[phoneNumberIndex + 4].toUpperCase() === t('details.yes') : false,
                                    electromobility: this.state.element.multienergeticSelected ? true : false,
                                });
                            }
                        });
                    }
                    this.setState(
                        (prevState) => ({
                            ...prevState,
                            progressVisible: false,
                            fileProgress: parseInt(100),
                            element: {
                                ...prevState.element,
                                cardList: modifiedList,
                            },
                        }),
                        () => console.log('PROGRESS VISIBILE', this.state.fileProgress)
                    );
                    this.unblockUi();
                })
                .catch((err) => {
                    this.setState({file: undefined, fileProgress: parseInt(0), progressVisible: false}, () => {
                        this.showErrorMessage(t('error.xlsxFileUploadError'));
                        this.unblockUi();
                    });
                });
        }
    }
    setAllPlastic() {
        this.blockUi();
        const modifiedList = this.state.element.cardList;
        let requests = modifiedList.map((item) => {
            return new Promise((resolve) => {
                this.changePlasticForCard(item, resolve);
            });
        });
        Promise.all(requests).then(() => {
            this.setState(
                (prevState) => ({
                    ...prevState,
                    element: {
                        ...prevState.element,
                        cardList: modifiedList,
                    },
                }),
                () => this.unblockUi()
            );
        });
    }
    setAllCardsLimitedAccess() {
        this.blockUi();
        const modifiedList = this.state.element.cardList;
        let requests = modifiedList.map((item) => {
            return new Promise((resolve) => {
                this.changeLimitedAccessForCard(item, resolve);
            });
        });
        Promise.all(requests).then(() => {
            this.setState(
                (prevState) => ({
                    ...prevState,
                    element: {
                        ...prevState.element,
                        cardList: modifiedList,
                    },
                }),
                () => this.unblockUi()
            );
        });
    }
    changeRoleForAll() {
        this.blockUi();
        const modifiedList = this.state.element.cardList;
        let requests = modifiedList.map((item) => {
            return new Promise((resolve) => {
                this.changeRoleForCard(item, resolve);
            });
        });
        Promise.all(requests).then(() => {
            this.setState(
                (prevState) => ({
                    ...prevState,
                    element: {
                        ...prevState.element,
                        cardList: modifiedList,
                    },
                }),
                () => this.unblockUi()
            );
        });
    }
    changeRoleForCard(item, resolve) {
        item.accountRole = this.state.allRole;
        resolve();
    }
    changePlasticForCard(item, resolve) {
        item.plastic = this.state.allPlastic;
        resolve();
    }
    changeLimitedAccessForCard(item, resolve) {
        item.limitedAccess = this.state.allLimitedAccess;
        resolve();
    }
    handleAfterRemoveFile() {
        this.setState({file: undefined});
    }
    vehicleTypeMapToColumnName(){
        let countOfVehicleTypes = this.state.vehicleTypeOpt.length;
        let textInBrackets =  this.state.vehicleTypeOpt.map((val, index) => {      
            if(index + 1 === countOfVehicleTypes){
                return " " + val.label + ")";
            } else {
                return " " + val.label;
            }
        });
        return "Typy pojazdów (" + textInBrackets;
    }
    downloadFile() {
        const {t} = this.props;
        const columns = [];
        if (this.state.element.cardKind === 'VEHICLE' || this.state.element.cardKind === 'VEHICLE_PERSON') {
            columns.push(t('order-card.registrationNumber'));
        }
        if (this.state.element.cardKind === 'PERSON' || this.state.element.cardKind === 'VEHICLE_PERSON') {
            columns.push(t('order-card.fullName'));
        }
        columns.push(t('order-card.phoneNumber'));
        columns.push(`${t('order-card.role')} (DRIVER, ADMIN)`);
        columns.push(`${t('order-card.card')} (${t('details.yes')}, ${t('details.no')})`);
        if(this.state.vehicleTypeOpt !== undefined && this.state.vehicleTypeOpt.length > 0){
            columns.push(this.vehicleTypeMapToColumnName())
        }
        if(this.user.limitedAccess === true){
            columns.push(`${t('order-card.limitedAccess')} (${t('details.yes')}, ${t('details.no')})`);
        }
        const request = {
            columns: columns,
            templateName: `${t('order-card.templateFilename')}.xlsx`,
        };
        this.cardOrderTemplateService.getTemplateFile(request, `${t('order-card.templateFilename')}.xlsx`, this.showErrorMessage);
    }
    showProgres() {
        this.setState({progressVisible: true});
    }
    showConfirmationRemoveFileDialog() {
        this.setState({removeFileConfirmationVisible: true});
    }
    hideConfirmationRemoveFileDialog(confirm) {
        if (!!confirm) {
            this.setState({removeFileConfirmationVisible: false, file: undefined, fileProgress: 0});
        } else {
            this.setState({removeFileConfirmationVisible: false});
        }
    }
    renderEmptyFileTemplate() {
        const {t} = this.props;
        return (
            <div className='p-fileupload p-fileupload-advanced p-component'>
                <div className='p-fileupload-content empty'>
                    <div className='p-fileupload-files'>
                        <div className='p-fileupload-row'>
                            <div className='order-card-file'>
                                <MenuItemIcon alt='' className='col-12 drag-icon' iconSvg={'ico_drag_file'} />
                                {!this.state.file ? (
                                    <React.Fragment>
                                        <label className='col-12'>{t('order-card.uploadIconLabel')}</label>
                                    </React.Fragment>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    plasticTemplate() {
        const {t} = this.props;
        return (
            <div className='card-type-column-header'>
                <InputCheckboxComponent
                    id={'allPlastic'}
                    name='allPlastic'
                    label={t('order-card.shortPlasticLabel')}
                    // renderLabel={() => {
                    //     return (
                    //         <div className='col-12'>
                    //             <label
                    //                 id={`order-plastic-confirmation-price-label-id`}
                    //                 className='colorfull-label plastic-header-label'
                    //                 style={{backgroundColor: '#FD6F1F'}}
                    //             >
                    //                 {this.state.orderPlasticCardPrice} {t('currency.pln')}/{t('details.item')}
                    //             </label>
                    //         </div>
                    //     );
                    // }}
                    labelOnRight
                    value={this.state.allPlastic}
                    validator={this.validator}
                    onChange={this.handleChange}
                    viewMode={'EDIT'}
                    colClass='col-12'
                    labelClassName='p-checkbox-label plastic-label'
                    insideTable
                    stateField=''
                    onAfterStateChange={() => {
                        this.setAllPlastic();
                    }}
                />
            </div>
        );
    }
    virtualTemplate() {
        const {t} = this.props;
        return (
            <div className='card-type-column-header'>
                <InputCheckboxComponent
                    id={'plasticCardOrderDialog'}
                    name='plasticCardOrder'
                    label={t('order-card.virtual')}
                    // renderLabel={() => {
                    //     return (
                    //         <div className='col-12'>
                    //             <label
                    //                 id={`order-plastic-confirmation-price-label-id`}
                    //                 className='colorfull-label virtual-header-label'
                    //                 style={{backgroundColor: '#1AB759'}}
                    //             >
                    //                 {t('order-card.free')}
                    //             </label>
                    //         </div>
                    //     );
                    // }}
                    labelOnRight
                    value={true}
                    validator={this.validator}
                    onChange={this.handleChange}
                    viewMode={'EDIT'}
                    disabled
                    colClass='col-12'
                    labelClassName='p-checkbox-label disabled-label virtual-label'
                />
            </div>


        );
    }
    bannerTemplate(rowdata) {
        const {t} = this.props;
       if(rowdata.plastic === false)  {
        return (

            <div className='fleet-good-group-banner-virtual-only with-min-width'>
        <BannerComponent
            key={'header-banner'}
            subLabel={t('cards.virtualCardTypeInfoBanner')}
            iconSvg='ico_blue_banner_icon'
            iconSide='left'
            variant='white-banner'
        ></BannerComponent>
        </div>

  );
       } else { return null;}

    }

        limitedAccessTemplate() {
        const {t} = this.props;
        return (
            <div className='card-type-column-header'>
                <InputCheckboxComponent
                    id={'allLimitedAccess'}
                    name='allLimitedAccess'
                    label={t('order-card.limitedAccess')}
                    labelOnRight
                    value={this.state.allLimitedAccess}
                    validator={this.validator}
                    onChange={this.handleChange}
                    viewMode={'EDIT'}
                    colClass='col-12'
                    labelClassName='p-checkbox-label plastic-label'
                    insideTable
                    stateField=''
                    onAfterStateChange={() => {
                        this.setAllCardsLimitedAccess();
                    }}
                    validators='not_required'
                />
            </div>
        );
    }
    crossFieldValidation(field, rowData) {
        if (field === 'phoneNumber') {
            if (rowData !== undefined && !rowData.plastic) {
                return 'required';
            } else {
                return 'not_required';
            }
        } else {
            return undefined;
        }
    }
    renderThirdPage() {
        const {t} = this.props;
        const limitedAccess = this.user.limitedAccess === true ?  true : false;
        const cardColumns = [
            {
                field: 'lp',
                header: 'Lp.',
                editable: () => false,
                editor: 'LP',
            },
        ];
        if (this.state.element.cardKind === 'VEHICLE' || this.state.element.cardKind === 'VEHICLE_PERSON') {
            cardColumns.push({
                field: 'vehicleRegistration',
                header: t('order-card.registrationNumber'),
                editor: 'TEXT',
                editable: true,
                validators: 'required|alpha_num|max:10',
                forceUpperCase: true,
                keyfilter: /^[A-Z0-9]*$/i,
            });
        }
        if (this.state.element.cardKind === 'PERSON' || this.state.element.cardKind === 'VEHICLE_PERSON') {
            cardColumns.push({
                field: 'driver',
                header: t('order-card.fullName'),
                editor: 'TEXT',
                max: 32,
                editable: true,
                validators: 'required|alpha_space_dash|max:32',
                keyfilter: /^[A-ZĄĆĘŁŃÓŚŹŻ\s-]*$/i,
                forceUpperCase: true,
            });
        }
        cardColumns.push({
            field: 'phoneNumber',
            header: t('order-card.phoneNumber'),
            editor: 'PHONE_NUMBER',
            labelCode: t('cards.phoneNumberCode'),
            labelPhoneNumber: t('cards.phoneNumber'),
            editable: true,
            validators: 'not_required',
            telephoneCodeOptions: this.state.telephoneCodeOptions,
        });
        cardColumns.push({
            field: 'accountRole',
            header: t('order-card.role'),
            editor: 'DROPDOWN',
            optionLabel: 'label',
            dataKey: 'enumValue',
            enumMode: true,
            enumName: 'CardRole',
            optionValue: 'enumValue',
            options: this.state.roleOpt,
            editable: true,
            validators: 'required|card_role_valid',
        });
        cardColumns.push({
            field: 'vehicleType',
            header: t('order-card.vehicleType'),
            editor: 'DROPDOWN',
            optionLabel: 'label',
            dataKey: 'code',
            enumMode: true,
            optionValue: 'code',
            options: this.state.vehicleTypeOpt,
            editable: true,
            validators: `required|vehicle_type_valid:${this.state.vehicleTypeOpt?.map(c => c.code).toString()}`,
        });
        cardColumns.push({
            field: 'virtual',
            header: this.virtualTemplate.bind(this),
            editor: 'CHECKBOX',
            editable: true,
            disabled: true,
            validators: 'not_required',
        });
        cardColumns.push({
            field: 'plastic',
            header: this.plasticTemplate.bind(this),
            editor: 'CHECKBOX',
            editable: true,
            validators: 'not_required',
        });
        if(limitedAccess === true){
            cardColumns.push({
                field: 'limitedAccess',
                header: this.limitedAccessTemplate.bind(this),
                editor: 'CHECKBOX',
                editable: true,
                validators: 'not_required',
            })
        }

        cardColumns.push({
            disabled: true,
            validators: 'not_required',
            body:this.bannerTemplate.bind(this)
        }
    );
        return (
            <React.Fragment>
                <div className='row'>
                    <label id='list-title-third-page' className='header'>{`3. ${t('order-card.cardData')}`}</label>
                </div>
                <DivContainer colClass='dashboard'>
                    <DivContainer colClass='col-12 col-12 dashboard-link-container card-order'>
                        <DivContainer colClass='row'>
                            <DivContainer colClass='col-12'>
                                <Card header={this.renderImportHeader()}>
                                    <div className='row'>
                                        <div className='row row-32'>
                                            <label className='font-14-400 gray'>{t('order-card.importDescription')}</label>
                                        </div>
                                        <DivContainer colClass='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                                            <label className='font-12-700 text-iron text-left col-12 mb-3'>{`1. ${t(
                                                'order-card.downloadTemplateFile'
                                            )}`}</label>
                                            <ActionButton
                                                id={'download-template-button'}
                                                label={t('order-card.downloadTemplate')}
                                                key={`download-${t('order-card.downloadTemplate')}`}
                                                className='p-link order-card download-template-button'
                                                variant='accent white'
                                                handleClick={(e) => {
                                                    e.preventDefault();
                                                    this.downloadFile();
                                                }}
                                                downloadFile
                                                iconSvg={'ico_download_link_icon'}
                                                iconSide='left'
                                            />
                                        </DivContainer>
                                        <DivContainer colClass='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                                            <label className='font-12-700 text-iron mb-3'>{`2. ${t(
                                                'order-card.insertDataIntoTemplate'
                                            )}`}</label>
                                            <div className='excel_template'>
                                                <MenuItemIcon alt='' iconSvg={'ico_cards_xlsx_icon'} />
                                            </div>
                                        </DivContainer>
                                        <DivContainer colClass='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                                            <label className='font-12-700 text-iron mb-3'>{`3. ${t('order-card.importFilledFile')}`}</label>
                                            <React.Fragment>
                                                <YesNoDialog
                                                    visible={this.state.removeFileConfirmationVisible}
                                                    header='Usunięcie pliku'
                                                    name='visible'
                                                    onChange={(type, x, target) => {
                                                        this.hideConfirmationRemoveFileDialog(target.value);
                                                    }}
                                                    onHide={() => {
                                                        this.hideConfirmationRemoveFileDialog(false);
                                                    }}
                                                    noButtonVariant='button cancel-button white'
                                                    yesButtonVariant='button save-button blue'
                                                >
                                                    {t('order-card.removeFileConfirmation')}
                                                </YesNoDialog>
                                                <InputFileChooseComponent
                                                    id='file'
                                                    name='file'
                                                    colClass={
                                                        this.state.file
                                                            ? 'order-card-upload-file col-12'
                                                            : 'order-card-upload-file-empty col-12'
                                                    }
                                                    multiple={false}
                                                    file={this.state.file}
                                                    showLabel={false}
                                                    viewMode='NEW'
                                                    label='Załącz plik'
                                                    onChange={this.handleChange}
                                                    validator={this.validator}
                                                    itemLabel='fileName'
                                                    maxFileSize={2000000}
                                                    maxFileCount={1}
                                                    validateViewMode
                                                    validators='not_required'
                                                    browseButton={
                                                        !this.state.file ? (
                                                            <div className='file-label'>
                                                                <img
                                                                    alt={t('order-card.uploadIconLabel')}
                                                                    src='/images/ico_drag_file.svg'
                                                                    className='file-label-icon'
                                                                />
                                                                <div className='file-label-text'>{t('order-card.uploadIconLabel')}</div>
                                                            </div>
                                                        ) : (
                                                            <div className='file-label'>
                                                                <img
                                                                    alt={t('order-card.sentFileLabel')}
                                                                    src='/images/ico_uploaded_to_remove_file.svg'
                                                                    className='file-label-icon'
                                                                />
                                                                <div className='file-label-text'>{t('order-card.sentFileLabel')}</div>
                                                            </div>
                                                        )
                                                    }
                                                    dragNdrop={true}
                                                    stateField=''
                                                    onAfterStateChange={this.handleAfterFileChange}
                                                    clickable={true}
                                                />
                                            </React.Fragment>
                                        </DivContainer>
                                    </div>
                                </Card>
                            </DivContainer>
                        </DivContainer>
                    </DivContainer>
                </DivContainer>
                <div className='row summary-row'>
                <div className='fleet-good-group-banner'>
                        <BannerComponent
                            key={'header-banner'}
                            label={t('cards.bannerOrderPlasticHeader')}
                            subLabel={t('cards.bannerOrderPlastic')}
                            iconSvg='ico_blue_banner_icon'
                            iconSide='left'
                            rendered={this.state.element.multienergeticSelected === true}
                            variant='white-banner'
                        ></BannerComponent>
                    </div>

                    <div className='left-part col-lg-6 col-sm-12'>
                        <div className='flex-container'>
                            <div className=''>
                                <ActionButton
                                    label={t('order-card.addCardButton')}
                                    variant={'blue big white-filter'}
                                    iconSvg='ico_white_plus'
                                    iconSide='left'
                                    iconColor=''
                                    colClass=''
                                    className=''
                                    handleClick={this.handleAddCard}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='right-summary col-lg-6 col-sm-12'>
                        <label className='font-12-500 flex-inputs inline-dropdown'>{t('order-card.sameRoleForAll')}:</label>
                        <InputDropdownComponent
                            id='allRole'
                            name='allRole'
                            showLabel={false}
                            colClass='title-dropdown flex-inputs'
                            value={this.state.allRole}
                            validator={this.validator}
                            options={this.state.roleOpt}
                            onChange={this.handleChange}
                            onAfterStateChange={this.changeRoleForAll}
                            viewMode={'EDIT'}
                            optionLabel='label'
                            dataKey='enumValue'
                            validators='not_required'
                            stateField=''
                            enumMode
                            enumName='CardRole'
                            optionValue='enumValue'
                        />
                    </div>
                </div>
                <DivContainer colClass='row'>
                    <EditableDataTableExt
                        crossFieldValidation={this.crossFieldValidation}
                        handleTranslate={t}
                        id={`cards-edition`}
                        name='cardList'
                        showLabel={false}
                        label={t('order-card.cards')}
                        paginator={true}
                        loading={!!this.state.progressVisible}
                        columns={cardColumns}
                        addedListName='addedList'
                        addedList={this.state.addedList}
                        modifiedListName='modifiedList'
                        modifiedList={this.state.modifiedList}
                        validator={this.validator}
                        viewMode={'EDIT'}
                        onChange={this.handleChange}
                        createNewElement={() => {}}
                        editable
                        showAddButton={false}
                        showDeleteButton
                        stateField={'element'}
                        dataKey='uuid'
                        //updateItemElementAfterEdit={this.updateItemElementAfterEdit}
                        ref={this.editableListRef}
                        className='col-12 order-card-table'
                        tableClassName='order-cards-table'
                        value={this.state.element.cardList}
                        publicMode
                        validators='array_required'
                        permanentDelete
                        deleteButtonClassName='float-left pi pi-trash no-underline'
                        showDeleteButtonLabel={false}
                        selectable
                        selection={this.state.selectedCards}
                        selectionMode='multiple'
                        selectionDataKey='uuid'
                        handleSelectionChange={(event) => {
                            const selectedCards = event.value;
                            const cardUuids = [];
                            selectedCards.forEach((el) => {
                                if (!!el && !!el.uuid) {
                                    cardUuids.push(el.uuid);
                                }
                            });
                            this.setState({
                                selectedCards,
                                selectedUuids: cardUuids,
                            });
                        }}
                    />
                </DivContainer>
                <div className='row summary-row'>
                    <div className='left-part col-lg-6 col-sm-12'>
                        <div className='flex-container'>
                            <div className=''>
                                <ActionButton
                                    label={`${t('order-card.deleteSelected')} (${this.state.selectedCards?.length})`}
                                    variant={'red'}
                                    colClass=''
                                    className=''
                                    handleClick={this.handleDeleteSelectedCards}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <DivContainer colClass='right-summary white-footer page-wide'>
                    <DivContainer colClass='row right-summary pt-4'>
                        <div className='col-xl-3 col-lg-4 col-md-12 col-sm-12'>
                            <label className='font-12-700 text-right font-blue inline-element'>{t('order-card.summaryLabel')}:</label>
                        </div>

                        <div className='col-xl-3 col-lg-4 col-md-12 col-sm-12'>
                            <label className='font-12-600 inline-element'>{t('order-card.cardsCount')}:</label>
                            <span className='font-12-600  margin-left-8'>
                                <NumberFormat
                                    value={this.state?.element?.cardList?.length}
                                    displayType={'text'}
                                    thousandSeparator=' '
                                    decimalSeparator=','
                                    fixedDecimalScale
                                    decimalScale={0}
                                    renderText={(value, props) => value}
                                />
                            </span>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-12 col-sm-12'>
                            <label className='font-12-600 inline-element '>{t('order-card.plasticCount')}:</label>
                            <span className='font-12-600  margin-left-8'>
                                <NumberFormat
                                    value={
                                        this.state?.element?.cardList?.length
                                            ? this.state.element.cardList.filter((c) => c.plastic === true)?.length
                                            : 0
                                    }
                                    displayType={'text'}
                                    thousandSeparator=' '
                                    decimalSeparator=','
                                    fixedDecimalScale
                                    decimalScale={0}
                                    renderText={(value, props) => value}
                                />
                            </span>
                        </div>
                        {/* <div className='col-xl-3 col-lg-4 col-md-12 col-sm-12'>
                            <label className='font-12-600 inline-element'>{t('order-card.plasticSum')}:</label>
                            <span className='font-12-600 margin-left-8'>
                                <NumberFormat
                                    value={
                                        this.state?.element?.cardList?.length
                                            ? this.state.element.cardList.filter((c) => c.plastic === true)?.length *
                                              this.state.orderPlasticCardPrice
                                            : 0
                                    }
                                    displayType={'text'}
                                    thousandSeparator=' '
                                    decimalSeparator=','
                                    fixedDecimalScale
                                    decimalScale={2}
                                    suffix={` ${t('currency.pln')}`}
                                    renderText={(value, props) => value}
                                />
                            </span>
                        </div> */}
                        {/* </div> */}
                        <div className='white-summary-buttons'>
                            <div className='row footer-buttons'>
                                {this.renderBackButton(2)}
                                {this.renderNextButton(4)}
                            </div>
                        </div>
                    </DivContainer>
                </DivContainer>
            </React.Fragment>
        );
    }

    renderFourthPage() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <DivContainer colClass='row'>
                    <div className='header'>{`4. ${t('details.summary')}`}</div>
                    <React.Fragment>
                        <DivContainer colClass='dashboard'>
                            <DivContainer colClass='col-12 dashboard-link-container card-order summary-order-card'>
                                <DivContainer colClass='row'>
                                    <DivContainer colClass='col-12'>
                                        <Card header={this.renderSummaryHeader()} className='card-order-summary-card'>
                                            <div className='row'>
                                                <DivContainer colClass='col-left col-xl-5 col-lg-5 col-md-12 col-sm-12 d-flex'>
                                                    <DivContainer colClass='col-12 dashboard-link-container gray-background'>
                                                        <Card className='center-all'>
                                                            <div className='row card-summary-type'>
                                                                <DivContainer colClass='card-summary-type-label'>
                                                                    <MenuItemIcon
                                                                        alt=''
                                                                        className={`max-88-icon`}
                                                                        iconSvg={`${
                                                                            this.state.element.cardKind === 'FIRM'
                                                                                ? 'ico_small_firm'
                                                                                : this.state.element.cardKind === 'VEHICLE'
                                                                                ? 'ico_small_vehicle'
                                                                                : this.state.element.cardKind === 'VEHICLE_PERSON'
                                                                                ? 'ico_small_vehicle_person'
                                                                                : this.state.element.cardKind === 'PERSON'
                                                                                ? 'ico_small_person'
                                                                                : ''
                                                                        }`}
                                                                    />
                                                                </DivContainer>
                                                                <DivContainer colClass='col-width-auto center-all card-summary-type-description'>
                                                                    <div className='row'>
                                                                        <label className='font-18-600 text-left font-blue col-12 margin-bottom-8'>
                                                                            {this.state.element.cardKind === 'FIRM'
                                                                                ? t('order-card.cardType_company')
                                                                                : this.state.element.cardKind === 'VEHICLE'
                                                                                ? t('order-card.cardType_vehicle')
                                                                                : this.state.element.cardKind === 'VEHICLE_PERSON'
                                                                                ? t('order-card.cardType_vehicle_person')
                                                                                : this.state.element.cardKind === 'PERSON'
                                                                                ? t('order-card.cardType_person')
                                                                                : ''}
                                                                        </label>
                                                                        <label className='p-label text-left col-12'>
                                                                            {this.state.element.cardKind === 'FIRM'
                                                                                ? t('order-card.cardType_company_desc')
                                                                                : this.state.element.cardKind === 'VEHICLE'
                                                                                ? t('order-card.cardType_vehicle_desc')
                                                                                : this.state.element.cardKind === 'VEHICLE_PERSON'
                                                                                ? t('order-card.cardType_vehicle_person_desc')
                                                                                : this.state.element.cardKind === 'PERSON'
                                                                                ? t('order-card.cardType_person_desc')
                                                                                : ''}
                                                                        </label>
                                                                    </div>
                                                                </DivContainer>
                                                            </div>
                                                        </Card>
                                                    </DivContainer>
                                                </DivContainer>
                                                <DivContainer colClass='col-right col-xl-7 col-lg-7 col-md-12 col-sm-12'>
                                                    <div className='row'>
                                                        <DivContainer colClass='dashboard'>
                                                            <DivContainer colClass='col-12 dashboard-link-container gray-background order-card-summary row-top'>
                                                                <DivContainer colClass='col-12'>
                                                                    <Card
                                                                        header={this.prepareHeader([
                                                                            {
                                                                                label: t('order-card.cardInApplication'),
                                                                                type: 'LABEL',
                                                                                className: 'transparent-background font-16-600',
                                                                                iconSvg: 'ico_virtual_card',
                                                                            },
                                                                        ])}
                                                                    >
                                                                        <DivContainer colClass='row'>
                                                                            <div className='col-width-auto'>
                                                                                <label className='p-label inline-element'>
                                                                                    {t('order-card.itemCount')}:
                                                                                </label>
                                                                                <span className='font-12-600  margin-left-8'>
                                                                                    <NumberFormat
                                                                                        value={this.state?.element?.cardList?.length}
                                                                                        displayType={'text'}
                                                                                        thousandSeparator=' '
                                                                                        decimalSeparator=','
                                                                                        fixedDecimalScale
                                                                                        decimalScale={0}
                                                                                        renderText={(value, props) => value}
                                                                                    />
                                                                                </span>
                                                                            </div>
                                                                            {/* <div className='col-width-auto'>
                                                                                <label className='p-label inline-element'>
                                                                                    {t('order-card.itemPrice')}:
                                                                                </label>
                                                                                <span className='font-12-600  margin-left-8'>
                                                                                    <NumberFormat
                                                                                        value={0}
                                                                                        displayType={'text'}
                                                                                        thousandSeparator=' '
                                                                                        decimalSeparator=','
                                                                                        fixedDecimalScale
                                                                                        decimalScale={2}
                                                                                        suffix={` ${t('currency.pln')}`}
                                                                                        renderText={(value, props) => value}
                                                                                    />
                                                                                </span>
                                                                            </div>
                                                                            <div className='col-width-auto'>
                                                                                <label className='p-label inline-element'>
                                                                                    {t('order-card.coast')}:
                                                                                </label>
                                                                                <span className='font-12-600 margin-left-8'>
                                                                                    <NumberFormat
                                                                                        value={0}
                                                                                        displayType={'text'}
                                                                                        thousandSeparator=' '
                                                                                        decimalSeparator=','
                                                                                        fixedDecimalScale
                                                                                        decimalScale={2}
                                                                                        suffix={` ${t('currency.pln')}`}
                                                                                        renderText={(value, props) => value}
                                                                                    />
                                                                                </span>
                                                                            </div> */}
                                                                        </DivContainer>
                                                                    </Card>
                                                                </DivContainer>
                                                            </DivContainer>
                                                        </DivContainer>
                                                    </div>
                                                    {this.state.element.multienergeticSelected === false ?
                                                    <div className='row'>
                                                    <DivContainer colClass='dashboard'>
                                                        <DivContainer colClass='col-12 dashboard-link-container gray-background order-card-summary row-bottom'>
                                                            <DivContainer colClass='col-12'>
                                                                <Card
                                                                    header={this.prepareHeader([
                                                                        {
                                                                            label: t('order-card.cardPlastic'),
                                                                            type: 'LABEL',
                                                                            className:
                                                                                'transparent-background font-16-600 plastic-card',
                                                                            iconSvg: 'ico_plastic_card',
                                                                        },
                                                                    ])}
                                                                >
                                                                    <DivContainer colClass='row'>
                                                                        <div className='col-width-auto'>
                                                                            <label className='p-label inline-element'>
                                                                                {t('order-card.itemCount')}:
                                                                            </label>
                                                                            <span className='font-12-600  margin-left-8'>
                                                                                <NumberFormat
                                                                                    value={
                                                                                        this.state?.element?.cardList?.length && this.state.element.multienergeticSelected ===false
                                                                                            ? this.state.element.cardList.filter(
                                                                                                  (c) => c.plastic === true
                                                                                              )?.length
                                                                                            : 0
                                                                                    }
                                                                                    displayType={'text'}
                                                                                    thousandSeparator=' '
                                                                                    decimalSeparator=','
                                                                                    fixedDecimalScale
                                                                                    decimalScale={0}
                                                                                    renderText={(value, props) => value}
                                                                                />
                                                                            </span>
                                                                        </div>
                                                                        {/* <div className='col-width-auto'>
                                                                            <label className='p-label inline-element'>
                                                                                {t('order-card.itemPrice')}:
                                                                            </label>
                                                                            <span className='font-12-600  margin-left-8'>
                                                                                <NumberFormat
                                                                                    value={this.state.orderPlasticCardPrice}
                                                                                    displayType={'text'}
                                                                                    thousandSeparator=' '
                                                                                    decimalSeparator=','
                                                                                    fixedDecimalScale
                                                                                    decimalScale={2}
                                                                                    suffix={` ${t('currency.pln')}`}
                                                                                    renderText={(value, props) => value}
                                                                                />
                                                                            </span>
                                                                        </div>
                                                                        <div className='col-width-auto'>
                                                                            <label className='p-label inline-element'>
                                                                                {t('order-card.coast')}:
                                                                            </label>
                                                                            <span className='font-12-600 margin-left-8'>
                                                                                <NumberFormat
                                                                                    value={
                                                                                        this.state?.element?.cardList?.length
                                                                                            ? this.state.element.cardList.filter(
                                                                                                  (c) => c.plastic === true
                                                                                              )?.length *
                                                                                              this.state.orderPlasticCardPrice
                                                                                            : 0
                                                                                    }
                                                                                    displayType={'text'}
                                                                                    thousandSeparator=' '
                                                                                    decimalSeparator=','
                                                                                    fixedDecimalScale
                                                                                    decimalScale={2}
                                                                                    suffix={` ${t('currency.pln')}`}
                                                                                    renderText={(value, props) => value}
                                                                                />
                                                                            </span>
                                                                        </div> */}
                                                                    </DivContainer>
                                                                </Card>
                                                            </DivContainer>
                                                        </DivContainer>
                                                    </DivContainer>
                                                </div> :
  <div className='row'>
  <DivContainer colClass='dashboard'>
      <DivContainer colClass='col-12 dashboard-link-container gray-background order-card-summary row-top'>
          <DivContainer colClass='col-12'>
              <Card
                  header={this.prepareHeader([
                      {
                          label: t('order-card.cardPlasticMultienergetic'),
                          type: 'LABEL',
                          className: 'transparent-background font-16-600',
                          iconSvg: 'ico_lightning_multienergetic_card',
                      },
                  ])}
              >
                  <DivContainer colClass='row'>
                      <div className='col-width-auto'>
                          <label className='p-label inline-element'>
                              {t('order-card.itemCount')}:
                          </label>
                          <span className='font-12-600  margin-left-8'>
                              <NumberFormat
                                   value={
                                      this.state?.element?.cardList?.length && this.state.element.multienergeticSelected ===true
                                          ? this.state.element.cardList.filter(
                                                (c) => c.plastic === true
                                            )?.length
                                          : 0
                                  }
                                  displayType={'text'}
                                  thousandSeparator=' '
                                  decimalSeparator=','
                                  fixedDecimalScale
                                  decimalScale={0}
                                  renderText={(value, props) => value}
                              />
                          </span>
                      </div>
                      {/* <div className='col-width-auto'>
                          <label className='p-label inline-element'>
                              {t('order-card.itemPrice')}:
                          </label>
                          <span className='font-12-600  margin-left-8'>
                              <NumberFormat
                                  value={0}
                                  displayType={'text'}
                                  thousandSeparator=' '
                                  decimalSeparator=','
                                  fixedDecimalScale
                                  decimalScale={2}
                                  suffix={` ${t('currency.pln')}`}
                                  renderText={(value, props) => value}
                              />
                          </span>
                      </div>
                      <div className='col-width-auto'>
                          <label className='p-label inline-element'>
                              {t('order-card.coast')}:
                          </label>
                          <span className='font-12-600 margin-left-8'>
                              <NumberFormat
                                  value={0}
                                  displayType={'text'}
                                  thousandSeparator=' '
                                  decimalSeparator=','
                                  fixedDecimalScale
                                  decimalScale={2}
                                  suffix={` ${t('currency.pln')}`}
                                  renderText={(value, props) => value}
                              />
                          </span>
                      </div> */}
                  </DivContainer>
              </Card>
          </DivContainer>
      </DivContainer>
  </DivContainer>
</div>
                                                }


                                                </DivContainer>
                                            </div>
                                        </Card>
                                    </DivContainer>
                                </DivContainer>
                            </DivContainer>
                        </DivContainer>
                        <DivContainer colClass='dashboard'>
                            <DivContainer colClass='col-12 dashboard-link-container card-order'>
                                <DivContainer colClass='row'>
                                    <DivContainer colClass='col-12'>
                                        <Card
                                            header={this.renderSummaryHeader('order-card.limitServices')}
                                            className='card-order-summary-card'
                                        >
                                            <DivContainer colClass='row'>
                                                <DivContainer colClass='col-12' rendered={!!this.state.element.monthlyAmountLimit}>
                                                    <label className='card-order-template-label'>
                                                        {`${t('order-card.monthlyAmountLimitSummary')}: `}
                                                        <span className='card-order-template-label-amount'>
                                                            {this.state.element.monthlyAmountLimit}
                                                        </span>
                                                    </label>
                                                </DivContainer>
                                                <DivContainer colClass='col-12' rendered={!!this.state.element.dailyVisitLimit}>
                                                    <label className='card-order-template-label'>
                                                        {`${t('cards.dailyVisitLimit')}: `}
                                                        <span className='card-order-template-label-amount'>
                                                            {this.state.element.dailyVisitLimit}
                                                        </span>
                                                    </label>
                                                </DivContainer>
                                                {(this.state.element.petrols &&
                                                    this.state.element.petrols.filter((p) => !!p.selected)?.length > 0) ||
                                                this.state.element.amountFuelLimit ||
                                                this.state.element.quantityFuelLimit ? (
                                                    <DivContainer colClass='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                                                        <div className='row limits'>
                                                            <DivContainer colClass='dashboard'>
                                                                <DivContainer colClass='col-12 dashboard-link-container gray-background order-card-summary row-top'>
                                                                    <Card>
                                                                        <div className='row'>
                                                                            <LimitsSummaryContainer
                                                                                t={this.props.t}
                                                                                element={this.state.element}
                                                                                listName='petrols'
                                                                                effectiveActiveIndex={0}
                                                                            />
                                                                        </div>
                                                                    </Card>
                                                                </DivContainer>
                                                            </DivContainer>
                                                        </div>
                                                    </DivContainer>
                                                ) : null}
                                                {(this.state.element.services &&
                                                    this.state.element.services.filter((p) => !!p.selected)?.length > 0) ||
                                                this.state.element.amountServiceLimit ? (
                                                    <DivContainer colClass='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                                                        <div className='row limits'>
                                                            <DivContainer colClass='dashboard'>
                                                                <DivContainer colClass='col-12 dashboard-link-container gray-background order-card-summary row-top'>
                                                                    <Card>
                                                                        <div className='row'>
                                                                            <LimitsSummaryContainer
                                                                                t={this.props.t}
                                                                                element={this.state.element}
                                                                                listName='services'
                                                                                effectiveActiveIndex={1}
                                                                            />
                                                                        </div>
                                                                    </Card>
                                                                </DivContainer>
                                                            </DivContainer>
                                                        </div>
                                                    </DivContainer>
                                                ) : null}
                                                {(this.state.element.products &&
                                                    this.state.element.products.filter((p) => !!p.selected)?.length > 0) ||
                                                this.state.element.amountNotFuelLimit ? (
                                                    <DivContainer colClass='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                                                        <div className='row limits'>
                                                            <DivContainer colClass='dashboard'>
                                                                <DivContainer colClass='col-12 dashboard-link-container gray-background order-card-summary row-top'>
                                                                    <Card>
                                                                        <div className='row'>
                                                                            <LimitsSummaryContainer
                                                                                t={this.props.t}
                                                                                element={this.state.element}
                                                                                listName='products'
                                                                                effectiveActiveIndex={2}
                                                                            />
                                                                        </div>
                                                                    </Card>
                                                                </DivContainer>
                                                            </DivContainer>
                                                        </div>
                                                    </DivContainer>
                                                ) : null}
                                            </DivContainer>
                                        </Card>
                                    </DivContainer>
                                </DivContainer>
                            </DivContainer>
                        </DivContainer>
                        <DivContainer colClass='dashboard'>
                            <DivContainer colClass='col-12 dashboard-link-container card-order'>
                                <Card>
                                    <DivContainer colClass='col-12'>
                                        <InputCheckboxComponent
                                            id={`template`}
                                            name='template'
                                            label={t('order-fuel.saveAsDraft')}
                                            labelOnRight
                                            value={this.state.element.template}
                                            validator={this.validator}
                                            onChange={this.handleChange}
                                            viewMode={'EDIT'}
                                            validators='not_required'
                                            colClass='col-12 big-checkbox'
                                        />
                                        <InputTextComponent
                                            id='draftName'
                                            name='name'
                                            label={t('order-card.draftName')}
                                            colClass='col-md-6 col-sm-12'
                                            value={this.state.element.name}
                                            placeholder={t('order-fuel.nameYourDraft')}
                                            viewMode={'EDIT'}
                                            validator={this.validator}
                                            validators='required'
                                            onChange={this.handleChange}
                                            rendered={!!this.state?.element?.template}
                                        />
                                    </DivContainer>
                                </Card>
                            </DivContainer>
                        </DivContainer>
                    </React.Fragment>
                </DivContainer>

                <DivContainer colClass='row right-summary white-footer page-wide'>
                    {/* <div className='col-12 text-right pt-4'>
                        <label className='font-12-600 inline-element '>{t('order-card.summaryAmount')}: </label>
                        <span className='font-12-600 font-blue margin-left-8'>
                            <NumberFormat
                                value={
                                    this.state?.element?.cardList?.length
                                        ? this.state.element.cardList.filter((c) => c.plastic === true)?.length *
                                          this.state.orderPlasticCardPrice
                                        : 0
                                }
                                displayType={'text'}
                                thousandSeparator=' '
                                decimalSeparator=','
                                fixedDecimalScale
                                decimalScale={2}
                                suffix={` ${t('currency.pln')}`}
                                renderText={(value, props) => value}
                            />
                        </span>
                    </div> */}
                    <div className='white-summary-buttons'>
                        <div className='row footer-buttons'>
                            {this.renderBackButton(3)}
                            <ActionButton
                                label={t('order-card.addToOrders')}
                                variant='back-button white m'
                                colClass=''
                                handleClick={(e) => {
                                    e.preventDefault();
                                    this.setState(
                                        (prevState) => ({
                                            ...prevState,
                                            element: {
                                                ...prevState.element,
                                                draft: true,
                                            },
                                        }),
                                        () => this.handleFormSubmit(e, 5)
                                    );
                                }}
                            />
                            {this.renderNextButton(5)}
                        </div>
                    </div>
                </DivContainer>
            </React.Fragment>
        );
    }
    renderBackButton(pageNumber) {
        const {t} = this.props;
        return (
            <ActionButton
                label={t('details.back')}
                variant={this.state.pageIndex === 5 ? 'back-button blue' : 'back-button white m'}
                colClass=''
                handleClick={
                    this.state.pageIndex !== 1 && this.state.pageIndex !== 5
                        ? (e) => {
                              e.preventDefault();
                              this.setState({pageIndex: pageNumber});
                              this.scrollToTop();
                          }
                        : this.props.handleBack
                        ? this.props.handleBack
                        : () => (window.location.href = this.props.backUrl)
                }
            />
        );
    }

    renderNextButton(pageNumber) {
        const {t} = this.props;
        let label;
        switch (this.state.pageIndex) {
            case 1:
                label = `${t('details.forward')} - ${t('order-card.setLimits')}`;
                break;
            case 2:
                label = `${t('details.forward')} - ${t('order-card.carddataNextButton')}`;
                break;
            case 3:
                label = `${t('details.forward')} - ${t('autoRegistration.summary')}`;
                break;
            case 4:
                label = t('order-card.placeOrder');
                break;
            case 5:
                label = t('order-card.orderFinalButton');
                break;
            default:
                label = t('details.forward');
                break;
        }
        return (
            <ActionButton
                label={label}
                variant='next-button blue m'
                colClass=''
                handleClick={(e) => {
                    e.preventDefault();
                    if (pageNumber === 5) {
                        this.setState(
                            (prevState) => ({
                                ...prevState,
                                element: {
                                    ...prevState.element,
                                    draft: false,
                                },
                            }),
                            () => this.handleFormSubmit(e, pageNumber)
                        );
                    } else {
                        this.handleFormSubmit(e, pageNumber);
                    }
                }}
            />
        );
    }

    createOrUpdate() {
        const {element} = this.state;
        const {t} = this.props;
        this.scrollToTop();
        if (this._isMounted) {
            this.blockUi();
            if (element.petraId === undefined || element.petraId === null) {
                this.service
                    .add(element)
                    .then((response) => {
                        if (response.id) {
                            this.afterAddSuccess(response);
                        } else {
                            this.unblockUi(() => {
                                if (!!response.errors) {
                                    response.errors.forEach((err) => this.showErrorMessage(t(`error.${err.errorCode}`)));
                                } else {
                                    this.showErrorMessage(t('error.addOrderCardError'));
                                }
                            });
                        }
                    })
                    .catch((err) => {
                        this.unblockUi();
                        this.showErrorMessage(t('error.addOrderCardError'));
                    });
            } else {
                this.service
                    .update(element)
                    .then((response) => {
                        this.afterUpdateSuccess(response);
                    })
                    .catch((err) => {
                        this.unblockUi();
                        this.showErrorMessage(t('error.addOrderCardTemplateError'));
                    });
            }
        }
    }

    afterAddSuccess(response) {
        this.unblockUi();
        this.setState({confirmationDialogVisibile: true, orderResponse: response});
    }
    afterUpdateSuccess(response) {
        this.unblockUi();
        this.setState({confirmationDialogVisibile: true, orderResponse: response});
    }
    handleCloseConfimationDialog() {
        this.setState({confirmationDialogVisibile: true, orderResponse: undefined}, () => {
            if (this.props.handleBack) {
                this.props.handleBack();
            } else {
                window.location.href = '/#/card-order-list';
            }
        });
    }

    validateCards() {
        const {t} = this.props;
        const {cardList} = this.state.element;
        return new Promise((resolve, reject) => {
            let valid = true;
            if (!this.state.element.cardList || this.state.element.cardList.length === 0) {
                this.showErrorMessage(t('error.noCardsError'));
                this.unblockUi();
                return;
            }
            if (this.state.element.cardKind === 'VEHICLE' || this.state.element.cardKind === 'VEHICLE_PERSON') {
                const blankRegistrationNumbers = cardList.filter(
                    (s) => !s.vehicleRegistration || s.vehicleRegistration === null || s.vehicleRegistration === ''
                );
                if (blankRegistrationNumbers && blankRegistrationNumbers.length && blankRegistrationNumbers.length > 0) {
                    this.showErrorMessage(t('error.registrationNumbersErrorInTable'));
                    return reject(valid);
                }
            }
            if (this.state.element.cardKind === 'VEHICLE_PERSON' || this.state.element.cardKind === 'PERSON') {
                const blankFullName = cardList.filter((s) => !s.driver || s.driver === null || s.driver === '');
                if (blankFullName && blankFullName.length && blankFullName.length > 0) {
                    this.showErrorMessage(t('error.errorFullNameInTable'));
                    return reject(valid);
                }
            }
            const blankPhoneNumber = cardList.filter(
                //TODO walidacja numeru telefonu
                (s) =>
                    !s.plastic &&
                    (s.phoneNumberCode === undefined ||
                        s.phoneNumberCode === null ||
                        s.phoneNumberValue === undefined ||
                        s.phoneNumberValue === null ||
                        s.phoneNumberValue === '' ||
                        s.phoneNumberValue.length < s.phoneNumberCode.minDigits ||
                        s.phoneNumberValue.length > s.phoneNumberCode.minDigits ||
                        s.phoneNumberValue.toString().match(/^[0-9]+$/) === null)
            );
            if (blankPhoneNumber && blankPhoneNumber.length && blankPhoneNumber.length > 0) {
                this.showErrorMessage(t('error.errorPhoneInTable'));
                return reject(valid);
            }
            const errorRoleInTable = cardList.filter((s) => !s.accountRole || s.accountRole === null || s.accountRole === undefined);
            if (errorRoleInTable && errorRoleInTable.length && errorRoleInTable.length > 0) {
                this.showErrorMessage(t('error.errorRoleInTable'));
                return reject(valid);
            }
            cardList.forEach((el) => {
                if (
                    el.phoneNumberCode !== undefined &&
                    el.phoneNumberCode !== null &&
                    el.phoneNumberValue !== undefined &&
                    el.phoneNumberValue !== null &&
                    el.phoneNumberValue !== ''
                ) {
                    el.phoneNumber = el.phoneNumberCode.code + el.phoneNumberValue;
                }
            });
            resolve(valid);
        });
    }

    handleValidForm(pageNumber) {
        this.validator.hideMessages();
        this.blockUi();
        if (pageNumber !== 5) {
            this.setState({pageIndex: pageNumber}, () => {
                this.unblockUi();
            });
            //   this.scrollToTop();
        } else {
            this.createOrUpdate();
        }
    }

    handleFormSubmit(event, pageNumber) {
        const {t} = this.props;
        if (event !== undefined) {
            event.preventDefault();
        }
        if(pageNumber>=3 && this.state.element.regularCardSelected &&  this.state.element?.petrols?.filter((p) => p.name==="ALL")?.map(p=>p.selected)[0] === true
        &&  this.state.element?.petrols?.filter((p) => p.name==="EV")?.map(p=>p.selected)[0] === false)
        {   let copyElement = [...this.state.element[`petrols`]];
            copyElement.forEach(el => {
                if(el.name === "EV"){
                    el.selected = false;
                }
                if(el.name === "ALL"){
                    el.selected = false;
                }
            })
            this.setState((prevState) => ({
                element: {
                    ...prevState.element,
                    [`petrols`]: copyElement
                },
            }));

        }
        if(pageNumber>4)
        {
            let copyElement = [...this.state.element.cardList];
            copyElement.forEach(el => {
                if( el.plastic === true){
                    el.virtual = false;
                }

            })
            this.setState((prevState) => ({
                element: {
                    ...prevState.element,
                    cardList: copyElement
                },
            }));

        }
        if (this.validator.allValid()) {
            if (pageNumber >= 4) {
                this.validateCards()
                    .then(() => this.handleValidForm(pageNumber))
                    .catch((err) => this.unblockUi());
            } else if (pageNumber >= 2 && !this.state.element.cardKind) {
                this.showErrorMessage(t('error.selectCardKind'));
                return;
            } 
            else if(pageNumber >= 3 && !this.state.element.regularCardSelected && !this.state.element.multienergeticSelected){
                this.showErrorMessage(t('error.selectCardType'));
                return;
            }
            else if (
                pageNumber >= 3 &&
                this.state.element?.petrols?.filter((p) => p.selected)?.length === 0 &&
                this.state.element?.services?.filter((p) => p.selected)?.length === 0 &&
                this.state.element?.products?.filter((p) => p.selected)?.length === 0
            ) {
                this.showErrorMessage(t('error.noProductsSelected'));
                return;
            } else {
                this.handleValidForm(pageNumber);
            }
        } else {

            this.validator.showMessages();
            // rerender to show messages for the first time
            this.scrollToError = true;
            this.forceUpdate();
        }
    }

    loaderType() {
        const {t} = this.props;
        const items = [
            {label: t('order-card.cardType')},
            {label: t('order-card.limitsStep')},
            {label: t('order-card.cardsData')},
            {label: t('details.summary')},
        ];
        return (
            <div className='col-xl-8 col-lg-12 col-md-12 col-sm-12'>
                <Steps
                    model={items}
                    activeIndex={this.state.pageIndex - 1}
                    icons
                    activeIconSrc='/images/ico_steps_check.svg'
                    completedIconsSrc='/images/ico_blue_dot_of_doom.svg'
                    nextIconsSrc='/images/ico_steps_next.svg'
                />
            </div>
        );
    }
    renderStepsNav() {
        const {t} = this.props;
        const items = [
            {label: t('order-card.cardType')},
            {label: t('order-card.limitsStep')},
            {label: t('order-card.cardsData')},
            {label: t('details.summary')},
        ];
        return (
            <div className='col-xl-8 col-lg-12 col-md-12 col-sm-12'>
                <Steps
                    model={items}
                    activeIndex={this.state.pageIndex - 1}
                    icons
                    activeIconSrc='/images/ico_steps_check.svg'
                    completedIconsSrc='/images/ico_blue_dot_of_doom.svg'
                    nextIconsSrc='/images/ico_steps_next.svg'
                />
            </div>
        );
    }

    render() {
        return (
            <BlockUi
                tag='div'
                className='container-fluid card-order-container-fluid'
                blocking={this.state.blocking || this.state.loading}
                loader={this.loader}
                rendered={!this.props.embedded}
            >
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} />
                <OrderCardConfirmationDialog
                    visible={this.state.confirmationDialogVisibile}
                    onHide={this.handleCloseConfimationDialog}
                    orderResponse={this.state.orderResponse}
                    className='confirm-dialog-width'
                    draft={this.state.element.draft}
                />
                {this.state.loading ? null : this.renderCard()}
                {this.state.selectedSelectableItem ? (
                    <CardAgreementTermDialog
                        id={`agreement-term-dialog`}
                        ariaCloseIconLabel={this.translate('dialog.closeDialog')}
                        selectedProductItem={this.state.selectedSelectableItem}
                        selectedPetrolFleetGroups={this.state.element.petrols}
                        regularCardSelected={this.state.element.regularCardSelected}
                        visible={this.state.agreementTermDialog}
                        blockUi={this.props.blockUi}
                        unblockUi={this.props.unblockUi}
                        showMessage={this.props.showMessage}
                        resizable={true}
                        className='agreement-term-dialog'
                        key={`agreement-term-dialog`}
                        handleReject={() => {}}
                        onHide={(e) => {
                            this.setState((prevState) => {
                                let p = this.state.selectedSelectableItem !== undefined ? this.state.selectedSelectableItem : 'ALL';
                                let allAgreementTermsAccepted = true;
                                this.state.element.petrols
                                    .filter((el) => el.agreementTermPetraId !== null)
                                    .forEach(
                                        (el) =>
                                            (allAgreementTermsAccepted =
                                                allAgreementTermsAccepted &&
                                                this.authService.isProductAgreementTermAccepted(el.agreementTermPetraId))
                                    );

                                const updatedElements = prevState.element.petrols.map((item) => {
                                    //jesli nie byl zaznaczony all, tylko cos innego
                                    if (
                                        p.name !== 'ALL' &&
                                        p.selected === true   ) {
                                        if( !this.authService.isProductAgreementTermAccepted(item.agreementTermPetraId)){
                                            //i zaznaczony checkbox ma przypisany regulamin do akceptacji
                                            if (item.name === p.name && item.selected === true) {
                                                //to odznacz ten przycisk skoro user nie zaakceptowal regulaminu
                                                return {...item, selected: false};
                                            }
                                            if (item.name === 'ALL' && item.selected === true) {
                                                //to odznacz ten przycisk skoro user nie zaakceptowal regulaminu
                                                return {...item, selected: false};
}
                                    } if(this.authService.isProductAgreementTermAccepted(item.agreementTermPetraId)){
                                         //i zaznaczony checkbox ma przypisany regulamin do akceptacji
                                         if (item.name === p.name && item.selected === true) {
                                            //to zaznacz ten przycisk skoro user  zaakceptowal regulamin
                                            return {...item, selected: true};
                                        }
                                        if (item.name === 'ALL' && item.selected === true) {
                                            //to zaznacz ten przycisk skoro user  zaakceptowal regulamin
                                            return {...item, selected: true};
                                    }
                                }
                                    }
                                    //jesli user zaznaczyl all i dla danego checkboxa jest przypisany regulamin
                                    if (p.name === 'ALL' && item.selected === true) {
                                        ///  let checkedData=  this.checkX(item);
                                        let checkIfItemAgreementsAccepted = allAgreementTermsAccepted; //this.checkOnlyAgreementAcceptation(item);

                                        //jesli zaznaczono all
                                        if (item.name === 'ALL' && item.selected === true) {
                                            if (checkIfItemAgreementsAccepted) {
                                                return {...item, selected: true};
                                            } else {
                                                //odznacz all
                                                return {...item, selected: false};
                                            }
                                        }
                                        if (item.name !== 'ALL' && item.selected === true && item.agreementTermPetraId !== null) {
                                            if (this.authService.isProductAgreementTermAccepted(item.agreementTermPetraId)) {
                                                return {...item, selected: true};
                                            } else {
                                                //odznacz all
                                                return {...item, selected: false};
                                            }
                                        }
                                        //jesli zaznaczono inny item do ktorego przypisany jest regulamin
                                    }
                                    if (item.name !== 'ALL' && item.selected === true && item.agreementTermFileName !== null) {
                                        if (p.name === item.name) {
                                            return {...item, selected: false};
                                        }
                                        //odznacz go
                                    }
                                    return item;
                                });
                                return {
                                    agreementTermDialog: false,
                                    selectedSelectableItem: undefined,
                                    element: {
                                        ...prevState.element,
                                        petrols: updatedElements,
                                    },
                                };
                            });
                        }}
                        closable={false}
                    ></CardAgreementTermDialog>
                ) : null}
            </BlockUi>
        );
    }

    renderCard() {
        return (
            <Card className='details-card' footer={this.renderFooter()}>
                <form onSubmit={this.handleFormSubmit} noValidate>
                    {this.renderDetails()}
                </form>
            </Card>
        );
    }

    renderDetails() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <div className='order-fuel'>
                    <div className='order-fuel-header'>
                        <div className='header-flex'>
                            <div className='title'>{t('order-card.title')}</div>
                            <ActionButton
                                className='back-button'
                                label={t('order-card.cancelOrdering')}
                                variant={'white'}
                                iconColor='blue'
                                href={this.props.backUrl}
                            />
                        </div>
                        <div>{this.renderStepsNav()}</div>
                    </div>

                    {this.state.pageIndex === 1 ? this.renderFirstPage() : null}
                    {this.state.pageIndex === 2 ? this.renderSecondPage() : null}
                    {this.state.pageIndex === 3 ? this.renderThirdPage() : null}
                    {this.state.pageIndex === 4 ? this.renderFourthPage() : null}
                    {this.state.pageIndex === 5 ? this.renderFinalPage() : null}
                </div>
            </React.Fragment>
        );
    }
}

CardOrderContainer.defaultProps = {
    backUrl: '/#/orders',
    element: undefined,
};

CardOrderContainer.propTypes = {
    backUrl: PropTypes.string,
    element: PropTypes.object,
    handleBack: PropTypes.func,
};

export default withTranslation()(CardOrderContainer);
